import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useState, useMemo } from "react";

import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import Navbar from "../Components/Navbar/navbar";
import NavbarCliente from "../Components/NavbarCliente/NavbarCliente";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { confirmarSistema, solicitarTextoSistema } from "../Components/PopupSistema/PopupSistema";
import { getAuth } from "firebase/auth";
import { serverTimestamp,getDoc } from "firebase/firestore";
import RelatorioRupturaPrint from "./RelatorioRupturaPrint";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import Autocomplete from "@mui/material/Autocomplete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import SettingsIcon from "@mui/icons-material/Settings";
import { useHistory, useLocation, useParams } from "react-router-dom";
import RelatorioTecnicoConsolidado from "./RelatorioTecnicoConsolidado";
import PaginationComponent from "../Components/PaginationComponents/paginationcomponents";
import PaginationSelector from "../Components/PaginationSelector/paginationselector";



import { db, storage } from "../Config/firebase";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  orderBy,
  query,
  where,
  limit,
  startAfter,
} from "firebase/firestore";
import { consultaTenantAtual, aplicarTenantAtual, getUsuarioAtualComTenant } from "../Utils/tenant";

const TAMANHO_PAGINA_MOLDAGENS = 20;
const TAMANHO_PAGINA_OBRAS_AGENDA = 20;
const TIPO_LAUDO_RUPTURAS = "Relatório de Rupturas";

function ehSlumpFlow(valor) {
  const numero = Number(String(valor ?? "").replace(",", "."));
  return Number.isFinite(numero) && numero > 300;
}

function formatarDataHistoricoAgenda(valor) {
  if (!valor) return "Data e hora não informadas";

  const data = valor?.toDate?.()
    || (valor?.seconds ? new Date(valor.seconds * 1000) : null)
    || (valor instanceof Date ? valor : new Date(valor));

  if (!(data instanceof Date) || Number.isNaN(data.getTime())) {
    return "Data e hora não informadas";
  }

  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

function formatarTipoHistoricoAgenda(tipo, descricao = "") {
  const tipos = {
    CRIACAO_MOLDAGEM: "Criação da moldagem",
    ALTERACAO_MOLDAGEM: "Alteração da moldagem",
    ALTERACAO_CAMINHAO: "Alteração do caminhão",
    CANCELAMENTO_CAMINHAO: "Cancelamento do caminhão",
    REATIVACAO_CAMINHAO: "Reativação do caminhão",
  };

  if (tipos[tipo]) return tipos[tipo];
  if (!tipo && /moldagem criada/i.test(descricao)) return "Criação da moldagem";
  return tipo ? String(tipo).replaceAll("_", " ").toLocaleLowerCase("pt-BR") : "Registro de alteração";
}

const ETAPAS_TUTORIAL_AGENDA_RUPTURA = [
  {
    titulo: "Conheça a Agenda de Ruptura",
    descricao:
      "A agenda reúne as obras, moldagens, caminhões, datas previstas de ruptura e resultados dos corpos de prova.",
    preview: "agenda:0",
    alt: "Tela da Agenda de Ruptura exibindo a lista de obras",
    dicas: [
      "Use a pesquisa para localizar rapidamente uma obra.",
      "Os filtros ajudam a separar obras cadastradas e relatórios pendentes.",
    ],
  },
  {
    titulo: "Selecione a obra",
    descricao:
      "Clique em uma obra para visualizar suas moldagens. Dentro da obra, use o botão Cadastrar Moldagem para iniciar um novo registro.",
    preview: "agenda:1",
    alt: "Tela da obra selecionada exibindo suas moldagens",
    dicas: [
      "Confirme se a obra correta está selecionada antes de cadastrar.",
      "Você pode pesquisar moldagens por data de moldagem ou data de ruptura.",
    ],
  },
  {
    titulo: "Cadastre a moldagem e os caminhões",
    descricao:
      "Informe cliente, obra, data da moldagem, concreteira e quem foi responsável pela moldagem. O nome da empresa SaaS aparece automaticamente como uma das opções.",
    preview: "agenda:2",
    alt: "Formulário atual de nova moldagem com o nome da empresa SaaS",
    dicas: [
      "A data da moldagem e a quantidade de caminhões são obrigatórias.",
      "Selecione a empresa SaaS ou a construtora/contratante como responsável.",
      "Revise as idades previstas de ruptura antes de salvar.",
    ],
  },
  {
    titulo: "Preencha caminhões, resultados e relatório",
    descricao:
      "Abra a moldagem para preencher notas, slump, peças concretadas e resultados de ruptura. Quando os dados estiverem revisados, gere o relatório da obra.",
    preview: "agenda:3",
    alt: "Tela atual de preenchimento dos dados da moldagem e caminhões",
    dicas: [
      "Salve as alterações antes de sair da moldagem.",
      "Confira resultados e datas antes de gerar ou revisar um relatório.",
    ],
  },
];

function obterNumeroRelatorioLaudo(laudo = {}) {
  const numeroDireto = Number(laudo.numeroRelatorio);
  if (Number.isInteger(numeroDireto) && numeroDireto > 0) return numeroDireto;

  const numeroNoTexto = String(
    laudo.descricao || laudo.nomeArquivo || ""
  ).match(/(?:rel[.\s_-]*|n[º°o.]?\s*|rupturas-)(\d+)/i);

  return numeroNoTexto ? Number(numeroNoTexto[1]) : null;
}

function campoCaminhaoPreenchido(valor) {
  if (valor === null || valor === undefined) return false;
  return typeof valor === "string" ? valor.trim() !== "" : true;
}

function caminhaoPossuiDados(caminhao = {}) {
  const possuiResultado = (caminhao.resultados || []).some(
    (resultado) =>
      campoCaminhaoPreenchido(resultado?.cp1) ||
      campoCaminhaoPreenchido(resultado?.cp2)
  );

  return (
    campoCaminhaoPreenchido(caminhao.notaFiscalRomaneio) ||
    campoCaminhaoPreenchido(caminhao.qtd) ||
    campoCaminhaoPreenchido(caminhao.slumpObtido) ||
    campoCaminhaoPreenchido(caminhao.pecaConcretada) ||
    campoCaminhaoPreenchido(caminhao.observacoes) ||
    possuiResultado
  );
}

const LinhaAgendaMemoizada = React.memo(
  function LinhaAgendaMemoizada({ children }) {
    return children;
  },
  (anterior, atual) =>
    anterior.ensaio === atual.ensaio &&
    anterior.rowIndex === atual.rowIndex &&
    anterior.idades === atual.idades &&
    anterior.areaCp === atual.areaCp &&
    anterior.somenteLeitura === atual.somenteLeitura &&
    anterior.moldagemId === atual.moldagemId &&
    anterior.obraId === atual.obraId &&
    anterior.codigoInicialCaminhao === atual.codigoInicialCaminhao &&
    anterior.listaMoldagensNumeracao === atual.listaMoldagensNumeracao
);

export default function AgendaRuptura({ open, isMobile }) {
  const history = useHistory();
  const location = useLocation();
  const { moldagemId } = useParams();
  const tipoUsuario = (localStorage.getItem("tipoUsuario") || "").toLowerCase();
  const somenteLeitura =
    tipoUsuario === "cliente" || location.state?.somenteLeitura === true;
  const obraInicialId = location.state?.obraId || null;
  const obraInicialNome = location.state?.obraNome || null;
  const voltarParaLaudos = location.state?.voltarParaLaudos === true;
    const [dataInicio, setDataInicio] = useState("");
const [dataFim, setDataFim] = useState("");
const [mostrarFiltroPeriodo, setMostrarFiltroPeriodo] = useState(false);
const [moldagensFiltradas, setMoldagensFiltradas] = useState([]);
  const [gerarRelatorioCompleto, setGerarRelatorioCompleto] = useState(false);
  const [modoRelatorioCompleto, setModoRelatorioCompleto] = useState(false);
  const [carregandoRelatorioCompleto, setCarregandoRelatorioCompleto] = useState(false);
  const [dadosRelatorioCompleto, setDadosRelatorioCompleto] = useState(null);
  const [openTipoRelatorio, setOpenTipoRelatorio] = useState(false);
  const [tipoGeracaoRelatorio, setTipoGeracaoRelatorio] = useState("novo");
  const [numeroRevisaoRelatorio, setNumeroRevisaoRelatorio] = useState("");
  const [pdfRevisaoAnterior, setPdfRevisaoAnterior] = useState(null);
  const [pdfAnteriorAutomatico, setPdfAnteriorAutomatico] = useState(null);
  const [uploadRelatorioAntigo, setUploadRelatorioAntigo] = useState(null);
  const [ultimoCodigoPaginaPdf, setUltimoCodigoPaginaPdf] = useState("");
  const [ultimoCodigoCaminhaoPdf, setUltimoCodigoCaminhaoPdf] = useState("");
  const [mostrarConfiguracaoCortePdf, setMostrarConfiguracaoCortePdf] = useState(false);
  const [salvandoRelatorioAntigo, setSalvandoRelatorioAntigo] = useState(false);
  const [usarSemPdfAnterior, setUsarSemPdfAnterior] = useState(false);
  const [exigirPdfAntigo, setExigirPdfAntigo] = useState(false);
  const [carregandoPdfAnterior, setCarregandoPdfAnterior] = useState(false);
  const [concreteiras, setConcreteiras] = useState([]);
  const [ensaios, setEnsaios] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [nomeEmpresaSaaS, setNomeEmpresaSaaS] = useState("Empresa responsável");
  const dataMoldagemInputRef = useRef(null);
  const [erroDataMoldagem, setErroDataMoldagem] = useState(false);
  const [openAvisoPrensa, setOpenAvisoPrensa] = useState(false);
  const [mensagemAvisoPrensa, setMensagemAvisoPrensa] = useState(
    "É necessário selecionar a prensa utilizada na ruptura antes de salvar."
  );
  const [openConfirmarCancelamento, setOpenConfirmarCancelamento] = useState(false);
  const [ensaioEditando, setEnsaioEditando] = useState(null);
  const [moldagemAtualId, setMoldagemAtualId] = useState(null);
  const [temAlteracao, setTemAlteracao] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [listaObrasAgenda, setListaObrasAgenda] = useState([]);
  const [obrasAgendaBusca, setObrasAgendaBusca] = useState(null);
  const [carregandoObrasAgenda, setCarregandoObrasAgenda] = useState(false);
  const [listaMoldagens, setListaMoldagens] = useState([]);
  const [listaMoldagensNumeracao, setListaMoldagensNumeracao] = useState([]);
  const [carregandoMoldagens, setCarregandoMoldagens] = useState(false);
  const [ultimaMoldagemDoc, setUltimaMoldagemDoc] = useState(null);
  const [temMaisMoldagens, setTemMaisMoldagens] = useState(false);
  const [paginaMoldagens, setPaginaMoldagens] = useState(0);
  const [itensPorPaginaMoldagens, setItensPorPaginaMoldagens] = useState(TAMANHO_PAGINA_MOLDAGENS);
  const [lastDocsMoldagens, setLastDocsMoldagens] = useState([]);
  const [paginasMoldagens, setPaginasMoldagens] = useState(1);
  const [obrasSistema, setObrasSistema] = useState([]);
  const [obraSelecionada, setObraSelecionada] = useState(null);
  const [obraSelecionadaId, setObraSelecionadaId] = useState(null);
  const [moldagemSelecionada, setMoldagemSelecionada] = useState(null);
  const [pesquisaObra, setPesquisaObra] = useState("");
  const [filtroRelatorioObra, setFiltroRelatorioObra] = useState("cadastrados");
  const [paginaObrasAgenda, setPaginaObrasAgenda] = useState(0);
  const [itensPorPaginaObrasAgenda, setItensPorPaginaObrasAgenda] = useState(TAMANHO_PAGINA_OBRAS_AGENDA);
  const [lastDocsObrasAgenda, setLastDocsObrasAgenda] = useState([]);
  const [paginasObrasAgenda, setPaginasObrasAgenda] = useState(1);
  const [pesquisaMoldagem, setPesquisaMoldagem] = useState("");
  const obraRelatorioRef = useRef(null);
  const auth = getAuth();
  const [openHistorico, setOpenHistorico] = useState(false);
  const [historico, setHistorico] = useState([]);
  const printRef = useRef();
  const [clientes, setClientes] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [pesquisaCliente, setPesquisaCliente] = useState("");
  const [modoPrint, setModoPrint] = useState(false);
  const [visualizacaoVeioDaLista, setVisualizacaoVeioDaLista] = useState(false);
  const [autoPrint, setAutoPrint] = useState(false);
  const [codigoInicialInput, setCodigoInicialInput] = useState("");
  const [codigoInicialCaminhaoInput, setCodigoInicialCaminhaoInput] = useState("");
const [mostrarInputCodigo, setMostrarInputCodigo] = useState(false);
const exibirCamposCodigoInicial = false;
const [obraDados, setObraDados] = useState(null);
  const [calibracoesPrensa, setCalibracoesPrensa] = useState([]);
  const [calibracoesExternasPrensa, setCalibracoesExternasPrensa] = useState([]);
  const confirmacoesPrensaVencidaRef = useRef(new Set());
  const [filtroPrensaExterna, setFiltroPrensaExterna] = useState("obra");
  const [estadoOriginalEdicao, setEstadoOriginalEdicao] = useState(null);
  const [navegacaoPendente, setNavegacaoPendente] = useState(null);
  const desbloquearNavegacaoRef = useRef(null);
  const [abrindoMoldagem, setAbrindoMoldagem] = useState(false);
const handlePrint = useReactToPrint({
  contentRef: printRef,
  documentTitle: "Relatorio_Ruptura",
});

useEffect(() => {
  let cancelado = false;

  getUsuarioAtualComTenant()
    .then((usuarioAtual) => {
      if (!cancelado && usuarioAtual.tenantNome) {
        setNomeEmpresaSaaS(usuarioAtual.tenantNome);
      }
    })
    .catch((error) => {
      console.error("Erro ao carregar o nome da empresa SaaS:", error);
    });

  return () => {
    cancelado = true;
  };
}, []);

function obraPassaFiltroRelatorio(obra) {
  if (filtroRelatorioObra === "todos") return true;

  const ultimaAlteracao = criadoEmMs(
    obra.ultimaalteracaoagendaruptura
  );
  const ultimoRelatorio = criadoEmMs(obra.ultimorelatsalvo);

  const relatorioPendente = (
    ultimaAlteracao > 0 &&
    (ultimoRelatorio === 0 || ultimaAlteracao > ultimoRelatorio)
  );

  if (filtroRelatorioObra === "pendentes") return relatorioPendente;

  return filtroRelatorioObra === "cadastrados" && obra.temMoldagemAgenda === true;
}


const obrasFiltradasAgenda = useMemo(() => {
  const texto = pesquisaObra.toLowerCase().trim();
  const base = texto ? (obrasAgendaBusca || []) : listaObrasAgenda;

  return base.filter((obra) => {
    const cliente = clientes.find((item) => item.id === obra.clienteId);
    const correspondePesquisa = [obra.nome, obra.cliente, obra.clienteNome, cliente?.nome]
      .some((valor) => contemTextoPesquisa(String(valor || "").toLowerCase(), texto));

    if (!correspondePesquisa) return false;
    return obraPassaFiltroRelatorio(obra);
  });
}, [listaObrasAgenda, obrasAgendaBusca, pesquisaObra, filtroRelatorioObra, clientes]);

const moldagensDaObraSelecionada = useMemo(() => {
  return listaMoldagens
    .filter((item) => {
      const correspondeObraId =
        obraSelecionadaId && item.obraId === obraSelecionadaId;
      const correspondeObraNome =
        obraSelecionada && item.obra === obraSelecionada;
      return correspondeObraId || correspondeObraNome;
    })
    .sort((a, b) => {
      const dataA = String(a.datamoldagem || "");
      const dataB = String(b.datamoldagem || "");
      const comparacaoData = dataB.localeCompare(dataA);

      if (comparacaoData !== 0) return comparacaoData;
      return criadoEmMs(b.criadoEm) - criadoEmMs(a.criadoEm);
    });
}, [listaMoldagens, obraSelecionada, obraSelecionadaId]);

function clonarDados(valor) {
  return JSON.parse(JSON.stringify(valor || null));
}

function criadoEmMs(valor) {
  if (!valor) return 0;
  if (typeof valor.toMillis === "function") return valor.toMillis();
  if (typeof valor.seconds === "number") return valor.seconds * 1000;

  const data = new Date(valor);
  return Number.isNaN(data.getTime()) ? 0 : data.getTime();
}

function obterPrimeiraNotaFiscal(moldagem = {}) {
  const caminhoes = Array.isArray(moldagem.caminhoes)
    ? [...moldagem.caminhoes]
    : [];

  caminhoes.sort(
    (a, b) => Number(a?.cod_caminhao || 0) - Number(b?.cod_caminhao || 0)
  );

  const primeiraNota = caminhoes.find((caminhao) =>
    String(caminhao?.notaFiscalRomaneio || "").trim()
  )?.notaFiscalRomaneio;
  const numeroNota = Number(String(primeiraNota || "").replace(/\D/g, ""));

  return Number.isFinite(numeroNota) && numeroNota > 0
    ? numeroNota
    : Number.MAX_SAFE_INTEGER;
}

function ordenarMoldagensPorNumeracao(a, b) {
  const data = (a.datamoldagem || "").localeCompare(b.datamoldagem || "");
  if (data !== 0) return data;

  const nota = obterPrimeiraNotaFiscal(a) - obterPrimeiraNotaFiscal(b);
  if (nota !== 0) return nota;

  return criadoEmMs(a.criadoEm) - criadoEmMs(b.criadoEm);
}


  const estadoInicial = {
   cliente: "",
  clienteId: null,
  obra: "",
  obraId: null,
  datamoldagem: "",
  inicioConcretagem: "",
  terminoConcretagem: "",
  moldador: "",
  concreteira: "",
  responsavelMoldagem: "concreto_engenharia",
  rupturaExterna: false,
  prensaRuptura: null,
  incluirObservacaoRelatorio: false,
  observacaoRelatorio: "",
  nomeTraco: "N/I",
  fckProjeto: "",
  slumpProjeto: "",
  toleranciaSlumpProjeto: "",
  tipoAreaCp: "10x20",
  areaCp: 7854,
  tipoCapeamento: "NEOPRENE",
  tipoLancamento: "bombeado",
  notaFiscalRomaneio: "",
  qtd: "",
  slumpObtido: "",
  pecaConcretada: "",
  qtdCaminhoes: "",
  qtdIdades: 0,
  idades: []
};

        const [form, setForm] = useState(estadoInicial);

        useEffect(() => {
          if (tipoUsuario === "cliente") return;

          async function carregarConcreteiras() {
            try {
              const snapshot = await getDocs(
                consultaTenantAtual(query(collection(db, "concreteiras"), orderBy("nome")))
              );
              setConcreteiras(
                snapshot.docs
                  .map((documento) => ({
                    id: documento.id,
                    ...documento.data()
                  }))
                  .filter((concreteira) => concreteira.ativo !== false)
              );
            } catch (error) {
              console.error("Erro ao carregar concreteiras:", error);
              setConcreteiras([]);
            }
          }

          carregarConcreteiras();
        }, [tipoUsuario]);

      async function registrarHistorico(tipo, descricao) {

        if (!moldagemAtualId) return;

        const user = auth.currentUser;

        await addDoc(
          collection(db, "tblAgendaRuptura", moldagemAtualId, "historico"),
          {
            usuario: user?.displayName || "Usuário desconhecido",
            uid: user?.uid || null,
            usuarioEmail: user?.email || "",
            data: serverTimestamp(),

            tipo,
            descricao
          }
        );
      }

      async function registrarAlteracaoAgendaRuptura(obraId) {
        if (!obraId) return;

        const obraRef = doc(db, "obras", obraId);

        await updateDoc(obraRef, {
          ultimaalteracaoagendaruptura: serverTimestamp()
        });

        const obraAtualizadaSnap = await getDoc(obraRef);
        if (obraAtualizadaSnap.exists()) {
          setListaObrasAgenda((listaAtual) =>
            listaAtual.map((obra) =>
              obra.id === obraId
                ? { id: obraAtualizadaSnap.id, ...obraAtualizadaSnap.data() }
                : obra
            )
          );
        }
      }

        async function carregarClientes() {
  // Se for cliente, nem tenta carregar (não tem permissão)
  if (tipoUsuario === "cliente") {
    setClientes([]);
    return;
  }
  
  const q = query(
    collection(db, "clientes"),
    orderBy("nome", "asc")
  );

  const snapshot = await getDocs(consultaTenantAtual(q));

  const lista = await Promise.all(
  snapshot.docs.map(async (docSnap) => {

  const data = docSnap.data();

  return {
    id: docSnap.id,
    ...data
  };
})
);

  setClientes(lista);
}

            async function abrirHistorico(idMoldagem) {

              const q = query(
                collection(db, "tblAgendaRuptura", idMoldagem, "historico"),
                orderBy("data", "desc")
              );

              const snapshot = await getDocs(q);

              const lista = await Promise.all(
  snapshot.docs.map(async (docSnap) => {

    const data = docSnap.data();
    let usuarioEmail = data.usuarioEmail || "";
    if (!usuarioEmail && data.uid) {
      try {
        const usuarioSnap = await getDoc(doc(db, "users", data.uid));
        usuarioEmail = usuarioSnap.exists() ? usuarioSnap.data()?.email || "" : "";
      } catch {
        usuarioEmail = "";
      }
    }

    // 🔥 buscar caminhões
    

    return {
      id: docSnap.id,
      ...data,
      usuarioEmail
    };
  })
);

              setHistorico(lista);
              setOpenHistorico(true);
            }

              async function alterarStatusCaminhao(id) {
              try {
                const caminhao = ensaios.find(c => c.id === id);
                if (!caminhao) return;

                const novoStatus =
                  caminhao.status === "cancelado" ? "ativo" : "cancelado";

                await updateDoc(
                  doc(db, "tblAgendaRuptura", moldagemAtualId, "caminhoes", id),
                  {
                    status: novoStatus
                  }
                );

                await registrarAlteracaoAgendaRuptura(
                  form.obraId || moldagemSelecionada?.obraId
                );

                await registrarHistorico(
                  novoStatus === "cancelado"
                    ? "CANCELAMENTO_CAMINHAO"
                    : "REATIVACAO_CAMINHAO",
                  `Caminhão ${caminhao.cod_caminhao} - Nota Fiscal ${
                    caminhao.notaFiscalRomaneio || "Não informada"
                  } foi ${
                    novoStatus === "cancelado" ? "cancelado" : "reativado"
                  }.`
                );

                carregarCaminhoes(moldagemAtualId);

              } catch (error) {
                console.error(error);
              }
            }

function formatarDataBR(dataISO) {
  if (!dataISO) return "";
  const [ano, mes, dia] = dataISO.split("-");
  return `${dia}/${mes}/${ano}`;
}

function normalizarDataValidadeISO(valor) {
  if (!valor) return "";

  if (typeof valor === "string") {
    if (/^\d{4}-\d{2}-\d{2}/.test(valor)) return valor.slice(0, 10);
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
      const [dia, mes, ano] = valor.split("/");
      return `${ano}-${mes}-${dia}`;
    }
  }

  const data = valor?.toDate ? valor.toDate() : valor instanceof Date ? valor : null;
  if (!data || Number.isNaN(data.getTime())) return "";

  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}

function obterDataVencimentoPrensaISO(prensa) {
  const dataInformada = normalizarDataValidadeISO(prensa?.dataVencimento);
  if (dataInformada) return dataInformada;

  const dataCalibracao = normalizarDataValidadeISO(prensa?.dataCalibracao || prensa?.data);
  const textoValidade = String(prensa?.validade || "").trim().toLowerCase().replace(",", ".");
  const quantidade = Number(textoValidade.match(/[\d.]+/)?.[0]);

  if (!dataCalibracao || !Number.isFinite(quantidade) || quantidade <= 0) return "";

  const [ano, mes, dia] = dataCalibracao.split("-").map(Number);
  const vencimento = new Date(ano, mes - 1, dia);

  if (textoValidade.includes("mes")) {
    vencimento.setMonth(vencimento.getMonth() + quantidade);
  } else {
    vencimento.setFullYear(vencimento.getFullYear() + quantidade);
  }

  return normalizarDataValidadeISO(vencimento);
}

async function confirmarPrensaCalibradaParaRupturas(prensa, datasRuptura = []) {
  if (prensa?.calibracaoExterna === true) return true;

  const dataVencimento = obterDataVencimentoPrensaISO(prensa);
  if (!dataVencimento) return true;

  const primeiraRupturaAposValidade = datasRuptura
    .map(normalizarDataValidadeISO)
    .filter((data) => data && data > dataVencimento)
    .sort()[0];

  if (!primeiraRupturaAposValidade) return true;

  return confirmarSistema(
    `A prensa que está utilizando não está calibrada para a ruptura de ${formatarDataBR(primeiraRupturaAposValidade)}. ` +
    `O certificado venceu em ${formatarDataBR(dataVencimento)}. Deseja continuar?`,
    {
      titulo: "Certificado da prensa vencido",
      textoConfirmar: "Continuar",
      textoCancelar: "Cancelar",
    }
  );
}

function formatarTimestampBR(valor) {
  const milissegundos = criadoEmMs(valor);
  if (!milissegundos) return "-";

  return new Intl.DateTimeFormat("pt-BR").format(new Date(milissegundos));
}

function formatarPrensaRuptura(prensa) {
  if (!prensa) return "";
  const partes = [
    prensa.codigo,
    prensa.empresa,
    prensa.equipamento,
    prensa.serie && `Serie ${prensa.serie}`,
    prensa.dataCalibracao && `Calibracao ${formatarDataBR(prensa.dataCalibracao)}`,
    prensa.dataVencimento && `Validade ${formatarDataBR(prensa.dataVencimento)}`,
  ].filter(Boolean);
  return partes.join(" - ");
}

function formatarTipoLancamento(tipoLancamento) {
  if (tipoLancamento === "bombeado") return "BOMBEADO";
  if (tipoLancamento === "convencional") return "DESCARGA DIRETA";
  if (tipoLancamento === "nao_informado") return "N/I";
  return "";
}

function impedirAlteracaoNumeroNoScroll(event) {
  event.target?.blur?.();
}

function normalizarNomeEmpreendimento(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function obraEstaAtiva(obra = {}) {
  const status = normalizarNomeEmpreendimento(obra.status || obra.Status || "");
  return obra.ativo !== false && !["inativo", "inativa", "desativado", "desativada", "cancelado", "cancelada"].includes(status);
}

function dividirEmLotes(lista = [], tamanho = 10) {
  const lotes = [];
  for (let i = 0; i < lista.length; i += tamanho) {
    lotes.push(lista.slice(i, i + tamanho));
  }
  return lotes;
}

function obterDataMarcadorAgenda(moldagem = {}) {
  return moldagem.atualizadoEm || moldagem.criadoEm || moldagem.datamoldagem || new Date();
}

async function montarMarcadoresMoldagemAgenda(obras = []) {
  const obrasPorId = new Map();
  const idsObras = [];
  const nomesObras = [];
  const obrasPorNomeNormalizado = new Map();
  const marcadores = new Map();

  obras.forEach((obra) => {
    if (obra?.id) {
      obrasPorId.set(obra.id, obra);
      idsObras.push(obra.id);
    }

    if (obra?.nome) {
      nomesObras.push(obra.nome);
      const nomeNormalizado = normalizarNomeEmpreendimento(obra.nome);
      if (!obrasPorNomeNormalizado.has(nomeNormalizado)) {
        obrasPorNomeNormalizado.set(nomeNormalizado, []);
      }
      obrasPorNomeNormalizado.get(nomeNormalizado).push(obra);
    }
  });

  function marcarObra(obra, moldagem) {
    if (!obra?.id) return;
    const marcadorAtual = marcadores.get(obra.id);
    const novoMarcador = obterDataMarcadorAgenda(moldagem);

    marcadores.set(obra.id, {
      temMoldagemAgenda: true,
      ultimaalteracaoagendaruptura:
        marcadorAtual?.ultimaalteracaoagendaruptura || obra.ultimaalteracaoagendaruptura || novoMarcador
    });
  }

  const consultasPorId = dividirEmLotes([...new Set(idsObras)]).map((lote) =>
    getDocs(consultaTenantAtual(query(collection(db, "tblAgendaRuptura"), where("obraId", "in", lote))))
  );

  const consultasPorNome = dividirEmLotes([...new Set(nomesObras.filter(Boolean))]).map((lote) =>
    getDocs(consultaTenantAtual(query(collection(db, "tblAgendaRuptura"), where("obra", "in", lote))))
  );

  const snapshots = await Promise.all([...consultasPorId, ...consultasPorNome]);

  snapshots.forEach((snapshot) => {
    snapshot.docs.forEach((docSnap) => {
      const moldagem = docSnap.data();

      if (moldagem.obraId && obrasPorId.has(moldagem.obraId)) {
        marcarObra(obrasPorId.get(moldagem.obraId), moldagem);
        return;
      }

      const obrasComMesmoNome = obrasPorNomeNormalizado.get(
        normalizarNomeEmpreendimento(moldagem.obra)
      ) || [];

      obrasComMesmoNome.forEach((obra) => marcarObra(obra, moldagem));
    });
  });

  return marcadores;
}

async function marcarObrasComMoldagemAgenda(obras = []) {
  if (!obras.length) return obras;

  const marcadores = await montarMarcadoresMoldagemAgenda(obras);

  return obras.map((obra) => {
    const marcador = marcadores.get(obra.id);

    return {
      ...obra,
      temMoldagemAgenda:
        Boolean(obra.ultimaalteracaoagendaruptura) || marcador?.temMoldagemAgenda === true,
      ultimaalteracaoagendaruptura:
        obra.ultimaalteracaoagendaruptura || marcador?.ultimaalteracaoagendaruptura
    };
  });
}

function filtrarCalibracoesPrensa(
  calibracoes,
  calibracoesExternas,
  rupturaExterna,
  criterioExterno,
  obra,
  cliente
) {
  if (rupturaExterna === true && criterioExterno === "calibracao-externa") {
    return calibracoesExternas.filter((prensa) => prensa.ativo !== false);
  }

  return calibracoes.filter((prensa) => {
    const usoInterno =
      prensa.usoInterno === true ||
      String(prensa.usoInterno || "").toLowerCase() === "true";

    if (rupturaExterna !== true) return usoInterno;
    if (criterioExterno === "todos") return true;
    if (usoInterno) return false;

    if (criterioExterno === "cliente") {
      return (
        normalizarNomeEmpreendimento(prensa.empresa || prensa.cliente) ===
        normalizarNomeEmpreendimento(cliente)
      );
    }

    return (
      normalizarNomeEmpreendimento(prensa.obra || prensa.empreendimento) ===
      normalizarNomeEmpreendimento(obra)
    );
  });
}

function obterFiltroPrensaSalva(prensa, obra, cliente) {
  if (!prensa) return "obra";
  if (prensa.calibracaoExterna === true) return "calibracao-externa";

  const clientePrensa = normalizarNomeEmpreendimento(
    prensa.empresa || prensa.cliente
  );
  const obraPrensa = normalizarNomeEmpreendimento(
    prensa.obra || prensa.empreendimento
  );

  if (
    clientePrensa &&
    clientePrensa === normalizarNomeEmpreendimento(cliente) &&
    obraPrensa !== normalizarNomeEmpreendimento(obra)
  ) {
    return "cliente";
  }

  return "obra";
}

async function carregarCalibracoesPrensa() {
  if (tipoUsuario === "cliente") {
    setCalibracoesPrensa([]);
    setCalibracoesExternasPrensa([]);
    return;
  }

  const [snapshot, externasSnapshot] = await Promise.all([
    getDocs(consultaTenantAtual(collection(db, "tblCalibracaoPrensas"))),
    getDocs(consultaTenantAtual(collection(db, "tblCalibracoesExternasPrensa")))
  ]);

  const lista = snapshot.docs
    .map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data()
    }))
    .sort((a, b) =>
      String(b.dataCalibracao || b.data || "").localeCompare(
        String(a.dataCalibracao || a.data || "")
      )
    );

  setCalibracoesPrensa(lista);
  setCalibracoesExternasPrensa(
    externasSnapshot.docs.map((docSnap) => {
      const dados = docSnap.data();
      return {
        id: docSnap.id,
        ...dados,
        codigo: dados.numeroCertificado || "",
        certificado: dados.numeroCertificado || "",
        equipamento: dados.descricaoEquipamento || "",
        calibracaoExterna: true
      };
    }).sort((a, b) => String(b.dataCalibracao || "").localeCompare(String(a.dataCalibracao || "")))
  );
}


async function buscarCaminhoesDaMoldagem(idMoldagem) {
  const snapshot = await getDocs(
    query(
      collection(db, "tblAgendaRuptura", idMoldagem, "caminhoes"),
      orderBy("cod_caminhao", "asc")
    )
  );

  return snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data()
  }));
}

async function gerarRelatorioPorPeriodo() {
  if (!dataInicio || !dataFim) {
    alert("Informe data inicial e final");
    return;
  }

  try {
  const filtrosObra = obraSelecionadaId
    ? [where("obraId", "==", obraSelecionadaId)]
    : [where("obra", "==", obraSelecionada)];

  const snapshot = await getDocs(
    consultaTenantAtual(query(
      collection(db, "tblAgendaRuptura"),
      ...filtrosObra
    ))
  );

  const filtradas = await Promise.all(
    snapshot.docs
    .map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data()
    }))
    .filter((moldagem) =>
      moldagem.datamoldagem &&
      moldagem.datamoldagem >= dataInicio &&
      moldagem.datamoldagem <= dataFim
    )
    .map(async (moldagem) => {
      const caminhoes = await buscarCaminhoesDaMoldagem(moldagem.id);

      return {
        ...moldagem,
        caminhoes
      };
    })
  );

  filtradas.sort(ordenarMoldagensPorNumeracao);

  if (filtradas.length === 0) {
    alert("Nenhuma moldagem encontrada no período");
    return;
  }

  setMoldagensFiltradas(filtradas);
  setModoPrint(true);
  setAutoPrint(false);
  } catch (error) {
    console.error("Erro ao gerar relatÃ³rio por perÃ­odo:", error);
    alert("NÃ£o foi possÃ­vel gerar o relatÃ³rio por perÃ­odo.");
  }
}

async function buscarPdfAntigoDaObra(obraId) {
  if (!obraId) return { exigirPdfAntigo: false, pdf: null };

  const obraSnap = await getDoc(doc(db, "obras", obraId));

  if (!obraSnap.exists()) return { exigirPdfAntigo: false, pdf: null };

  const dadosObra = obraSnap.data();
  const deveExigirPdfAntigo = Number(dadosObra.codigoInicial || 0) > 0;

  if (!deveExigirPdfAntigo || !dadosObra.relatorioAntigoRuptura?.storagePath) {
    return {
      exigirPdfAntigo: deveExigirPdfAntigo,
      pdf: null,
      ultimoCodigoPagina: dadosObra.codigoInicial ?? "",
      ultimoCodigoCaminhao: dadosObra.codigoInicialCaminhao ?? ""
    };
  }

  const relatorioAntigo = dadosObra.relatorioAntigoRuptura;

  const url =
    relatorioAntigo.url ||
    await getDownloadURL(ref(storage, relatorioAntigo.storagePath));

  return {
    exigirPdfAntigo: true,
    pdf: {
      nomeArquivo: relatorioAntigo.nomeArquivo || "relatorio-antigo.pdf",
      storagePath: relatorioAntigo.storagePath,
      url,
      ultimoCodigoPagina:
        relatorioAntigo.ultimoCodigoPagina ?? dadosObra.codigoInicial ?? "",
      ultimoCodigoCaminhao:
        relatorioAntigo.ultimoCodigoCaminhao ??
        dadosObra.codigoInicialCaminhao ??
        ""
    }
  };
}

function abrirGeracaoRelatorio(obra = null) {
  const obraId = obra?.id || obraSelecionadaId;
  obraRelatorioRef.current = obra || {
    id: obraSelecionadaId,
    nome: obraSelecionada
  };

  setTipoGeracaoRelatorio("novo");
  setNumeroRevisaoRelatorio("");
  setPdfRevisaoAnterior(null);
  setPdfAnteriorAutomatico(null);
  setUploadRelatorioAntigo(null);
  setUltimoCodigoPaginaPdf("");
  setUltimoCodigoCaminhaoPdf("");
  setMostrarConfiguracaoCortePdf(false);
  setUsarSemPdfAnterior(false);
  setExigirPdfAntigo(false);
  setOpenTipoRelatorio(true);

  if (obraId) {
    setCarregandoPdfAnterior(true);

    buscarPdfAntigoDaObra(obraId)
      .then((resultado) => {
        setExigirPdfAntigo(resultado.exigirPdfAntigo);
        setPdfAnteriorAutomatico(resultado.pdf);
        setUltimoCodigoPaginaPdf(
          (resultado.pdf?.ultimoCodigoPagina ?? resultado.ultimoCodigoPagina) != null
            ? String(resultado.pdf?.ultimoCodigoPagina ?? resultado.ultimoCodigoPagina)
            : ""
        );
        setUltimoCodigoCaminhaoPdf(
          (resultado.pdf?.ultimoCodigoCaminhao ?? resultado.ultimoCodigoCaminhao) != null
            ? String(resultado.pdf?.ultimoCodigoCaminhao ?? resultado.ultimoCodigoCaminhao)
            : ""
        );
      })
      .catch((error) => {
        console.error("Erro ao buscar PDF anterior:", error);
        setExigirPdfAntigo(false);
        setPdfAnteriorAutomatico(null);
      })
      .finally(() => setCarregandoPdfAnterior(false));
  }
}

async function salvarPdfAntigoDaObra() {
  const obraRelatorioId = obraRelatorioRef.current?.id || obraSelecionadaId;

  if (!obraRelatorioId) {
    alert("Selecione uma obra.");
    return;
  }

  if (!uploadRelatorioAntigo) {
    alert("Selecione o PDF que será usado como base.");
    return;
  }

  const ultimoCodigoPagina = Number(ultimoCodigoPaginaPdf);
  const ultimoCodigoCaminhao = Number(ultimoCodigoCaminhaoPdf);

  if (!Number.isInteger(ultimoCodigoPagina) || ultimoCodigoPagina < 0) {
    alert("Informe o último código de página existente no PDF.");
    return;
  }

  if (!Number.isInteger(ultimoCodigoCaminhao) || ultimoCodigoCaminhao < 0) {
    alert("Informe o último código de caminhão existente no PDF.");
    return;
  }

  try {
    setSalvandoRelatorioAntigo(true);

    const obraRef = doc(db, "obras", obraRelatorioId);
    const obraSnap = await getDoc(obraRef);
    if (!obraSnap.exists()) {
      throw new Error("Obra não encontrada.");
    }

    const dadosObra = obraSnap.data();
    const codigoBase = Number(
      dadosObra.relatorioAntigoRuptura?.codigoBasePagina ??
        dadosObra.codigoInicial ??
        0
    );
    const codigoBaseCaminhao = Number(
      dadosObra.relatorioAntigoRuptura?.codigoBaseCaminhao ??
        dadosObra.codigoInicialCaminhao ??
        0
    );

    if (ultimoCodigoPagina < codigoBase) {
      alert(`O código da página não pode ser menor que ${codigoBase}.`);
      return;
    }

    if (ultimoCodigoCaminhao < codigoBaseCaminhao) {
      alert(`O código do caminhão não pode ser menor que ${codigoBaseCaminhao}.`);
      return;
    }

    const storagePathAnterior = dadosObra.relatorioAntigoRuptura?.storagePath;

    const nomeArquivoSeguro = uploadRelatorioAntigo.name
      .replace(/[<>:"/\\|?*]/g, "")
      .replace(/\s+/g, " ")
      .trim();

    const storagePath = `relatorios-antigos-ruptura/${obraRelatorioId}/${nomeArquivoSeguro}`;

    await uploadBytes(ref(storage, storagePath), uploadRelatorioAntigo, {
      contentType: "application/pdf"
    });

    const url = await getDownloadURL(ref(storage, storagePath));

    await updateDoc(obraRef, {
      relatorioAntigoRuptura: {
        nomeArquivo: nomeArquivoSeguro,
        storagePath,
        url,
        codigoBasePagina: codigoBase,
        codigoBaseCaminhao,
        ultimoCodigoPagina,
        ultimoCodigoCaminhao,
        atualizadoEm: serverTimestamp()
      }
    });

    setPdfAnteriorAutomatico({
      nomeArquivo: nomeArquivoSeguro,
      storagePath,
      url,
      ultimoCodigoPagina,
      ultimoCodigoCaminhao
    });

    if (storagePathAnterior && storagePathAnterior !== storagePath) {
      deleteObject(ref(storage, storagePathAnterior)).catch((error) => {
        console.warn("Não foi possível excluir o PDF-base anterior:", error);
      });
    }

    setUploadRelatorioAntigo(null);

    alert("PDF-base e ponto de corte salvos com sucesso.");
  } catch (error) {
    console.error("Erro ao salvar PDF antigo:", error);
    alert("Não foi possível salvar o relatório antigo.");
  } finally {
    setSalvandoRelatorioAntigo(false);
  }
}

async function gerarRelatorioTecnicoCompleto(
  tipoGeracao = tipoGeracaoRelatorio,
  revisaoInformada = numeroRevisaoRelatorio
) {
  const obraRelatorioId = obraRelatorioRef.current?.id || obraSelecionadaId;
  const obraRelatorioNome = obraRelatorioRef.current?.nome || obraSelecionada;

  if (!obraRelatorioId && !obraRelatorioNome) {
    alert("Selecione uma obra.");
    return;
  }

  if (
    tipoGeracao === "revisao" &&
    (!/^\d+$/.test(revisaoInformada) || Number(revisaoInformada) <= 0)
  ) {
    alert("Informe um número de revisão válido.");
    return;
  }

  try {
    setCarregandoRelatorioCompleto(true);

    let numeroRelatorioInicial = null;
    if (obraRelatorioId) {
      const laudosSnap = await getDocs(
        consultaTenantAtual(query(collection(db, "laudos"), where("obraId", "==", obraRelatorioId)))
      );

      const numerosRelatorios = laudosSnap.docs
        .map((documento) => documento.data())
        .filter((laudo) => laudo.tipo === TIPO_LAUDO_RUPTURAS)
        .map(obterNumeroRelatorioLaudo)
        .filter((numero) => Number.isInteger(numero) && numero > 0);

      if (numerosRelatorios.length > 0) {
        const ultimoNumeroRelatorio = Math.max(...numerosRelatorios);
        numeroRelatorioInicial =
          tipoGeracao === "revisao"
            ? ultimoNumeroRelatorio
            : ultimoNumeroRelatorio + 1;
      } else {
        if (tipoGeracao === "revisao") {
          alert("Não existe relatório anterior nesta obra para gerar uma revisão.");
          return;
        }

        const informado = await solicitarTextoSistema(
          "Digite o número do primeiro relatório desta obra:",
          "1"
        );

        if (informado === null) return;

        numeroRelatorioInicial = Number(informado);
        if (!Number.isInteger(numeroRelatorioInicial) || numeroRelatorioInicial <= 0) {
          alert("Informe um número de relatório válido.");
          return;
        }
      }
    }

    const filtrosObra = obraRelatorioId
      ? [where("obraId", "==", obraRelatorioId)]
      : [where("obra", "==", obraRelatorioNome)];
    const moldagensSnap = await getDocs(
      consultaTenantAtual(query(collection(db, "tblAgendaRuptura"), ...filtrosObra))
    );

    let moldagens = await Promise.all(
      moldagensSnap.docs.map(async (documento) => ({
        id: documento.id,
        ...documento.data(),
        caminhoes: await buscarCaminhoesDaMoldagem(documento.id)
      }))
    );

    if (moldagens.length === 0) {
      alert("Nenhuma moldagem cadastrada para esta obra.");
      return;
    }

    moldagens.sort(ordenarMoldagensPorNumeracao);

    let obraRelatorio = obraDados;
    if (obraRelatorioId) {
      const obraSnap = await getDoc(doc(db, "obras", obraRelatorioId));
      if (obraSnap.exists()) {
        obraRelatorio = { id: obraSnap.id, ...obraSnap.data() };
      }
    }

    const ultimaAlteracaoRelatorio = criadoEmMs(
      obraRelatorio?.ultimaalteracaoagendaruptura
    );
    const ultimoRelatorioSalvo = criadoEmMs(obraRelatorio?.ultimorelatsalvo);
    const semAlteracaoDesdeUltimoSalvamento =
      ultimaAlteracaoRelatorio > 0 &&
      ultimoRelatorioSalvo > 0 &&
      ultimaAlteracaoRelatorio <= ultimoRelatorioSalvo;

    if (moldagens.length === 0) {
      alert("Não há páginas cadastradas para gerar o relatório.");
      return;
    }

    let clienteRelatorio =
      clientes.find((item) => item.id === obraRelatorio?.clienteId) || null;
    const clienteId = obraRelatorio?.clienteId || moldagens[0]?.clienteId;

    if (!clienteRelatorio && clienteId) {
      const clienteSnap = await getDoc(doc(db, "clientes", clienteId));
      if (clienteSnap.exists()) {
        clienteRelatorio = { id: clienteSnap.id, ...clienteSnap.data() };
      }
    }

    const prensasDasMoldagens = Array.from(
      new Map(
        moldagens
          .map((moldagem) => moldagem.prensaRuptura)
          .filter((prensa) => prensa?.id)
          .map((prensa) => [prensa.id, prensa])
      ).values()
    );
    const certificados = (
      await Promise.all(
        prensasDasMoldagens.map(async (prensa) => {
          const prensaId = prensa.id;
          if (prensa.calibracaoExterna === true) {
            const prensaExternaSnap = await getDoc(
              doc(db, "tblCalibracoesExternasPrensa", prensaId)
            );

            if (prensaExternaSnap.exists()) {
              const externa = prensaExternaSnap.data();
              return {
                id: prensaExternaSnap.id,
                ...externa,
                codigo: externa.numeroCertificado || "",
                certificado: externa.numeroCertificado || "",
                equipamento: externa.descricaoEquipamento || "",
                calibracaoExterna: true
              };
            }

            return prensa;
          }

          const prensaSnap = await getDoc(
            doc(db, "tblCalibracaoPrensas", prensaId)
          );

          if (prensaSnap.exists()) {
            return { id: prensaSnap.id, ...prensaSnap.data() };
          }

          return prensa;
        })
      )
    )
      .filter(Boolean)
      .sort((a, b) =>
        String(a.codigo || a.certificado || "").localeCompare(
          String(b.codigo || b.certificado || ""),
          "pt-BR",
          { numeric: true }
        )
      );

    const idsEquipamentosPadrao = new Set(
      certificados.map((certificado) => certificado.padraoEquipamentoId).filter(Boolean)
    );
    const documentosPadraoSnap = idsEquipamentosPadrao.size
      ? await getDocs(consultaTenantAtual(collection(db, "eq_documentos")))
      : null;
    const documentosPadraoPorEquipamento = {};

    documentosPadraoSnap?.docs.forEach((documentoSnap) => {
      const documento = { id: documentoSnap.id, ...documentoSnap.data() };
      if (!idsEquipamentosPadrao.has(documento.equipamentoId) ||
          !documento.storagePathAtual || documento.statusDocumento !== "ENVIADO" ||
          !["CELULA_DE_CARGA", "CERTIFICADO"].includes(documento.tipoDocumentoCodigo)) return;

      const atual = documentosPadraoPorEquipamento[documento.equipamentoId];
      const dataAtual = atual?.updatedAt?.toMillis?.() || atual?.createdAt?.toMillis?.() || 0;
      const dataNova = documento.updatedAt?.toMillis?.() || documento.createdAt?.toMillis?.() || 0;
      if (!atual || dataNova >= dataAtual) {
        documentosPadraoPorEquipamento[documento.equipamentoId] = documento;
      }
    });

    const certificadosComPadrao = certificados.map((certificado) => {
      const documentoPadrao = documentosPadraoPorEquipamento[certificado.padraoEquipamentoId];
      if (!documentoPadrao) return certificado;
      return {
        ...certificado,
        certificadoPadraoArquivo: documentoPadrao
      };
    });

    setDadosRelatorioCompleto({
  moldagens,
  certificados: certificadosComPadrao,
  cliente: clienteRelatorio,
  obra: obraRelatorio,
  numeroRelatorioInicial,
  tipoGeracaoRelatorio: tipoGeracao,
  numeroRevisaoRelatorio:
    tipoGeracao === "revisao" ? String(Number(revisaoInformada)) : "0",
  pdfRevisaoAnterior: null,
  semAlteracaoDesdeUltimoSalvamento
});

    setModoRelatorioCompleto(true);
    setOpenTipoRelatorio(false);
  } catch (error) {
    console.error("Erro ao gerar relatório técnico:", error);
    alert("Não foi possível gerar o relatório técnico.");
  } finally {
    setCarregandoRelatorioCompleto(false);
  }
}
  /* =========================
     CARREGAR CAMINHÕES
  ========================= */
  async function carregarCaminhoes(idMoldagem) {
    if (!idMoldagem) {
      setEnsaios([]);
      return [];
    }

    const q = query(
      collection(db, "tblAgendaRuptura", idMoldagem, "caminhoes"),
      orderBy("cod_caminhao", "asc")
    );

    // A subcoleção não possui tenantId. O acesso ao tenant é validado pelas
    // regras do Firestore a partir do documento pai da moldagem.
    const snapshot = await getDocs(q);

    const lista = await Promise.all(
  snapshot.docs.map(async (docSnap) => {

  const data = docSnap.data();

  return {
    id: docSnap.id,
    ...data
    };
  })
);

    setEnsaios(lista);
    return lista;
 
  }
  useEffect(() => {
  carregarClientes(); 
  if (tipoUsuario !== "cliente") {
    carregarCalibracoesPrensa();
  }
}, []);

useEffect(() => {
  setObrasAgendaBusca(null);
  setPaginaObrasAgenda(0);
  setLastDocsObrasAgenda([]);
  setPaginasObrasAgenda(1);
}, [pesquisaObra, filtroRelatorioObra, itensPorPaginaObrasAgenda]);

useEffect(() => {
  if (obraSelecionada || somenteLeitura) return;
  if (pesquisaObra.trim()) return;
  carregarObrasAgenda(paginaObrasAgenda);
}, [
  paginaObrasAgenda,
  itensPorPaginaObrasAgenda,
  pesquisaObra,
  filtroRelatorioObra,
  obraSelecionada,
  somenteLeitura
]);

useEffect(() => {
  if (obraSelecionada || somenteLeitura) return;
  if (!pesquisaObra.trim()) return;
  carregarObrasAgendaParaBusca();
}, [pesquisaObra, filtroRelatorioObra, obraSelecionada, somenteLeitura]);

useEffect(() => {
  function confirmarSaida(event) {
    if (!temAlteracao) return;

    event.preventDefault();
    event.returnValue = "";
  }

  window.addEventListener("beforeunload", confirmarSaida);
  return () => window.removeEventListener("beforeunload", confirmarSaida);
}, [temAlteracao]);

useEffect(() => {
  if (!temAlteracao) return undefined;

  desbloquearNavegacaoRef.current = history.block((location) => {
    setNavegacaoPendente(location);
    setOpenConfirmarCancelamento(true);
    return false;
  });

  return () => {
    desbloquearNavegacaoRef.current?.();
    desbloquearNavegacaoRef.current = null;
  };
}, [history, temAlteracao]);



            useEffect(() => {
              if (moldagemAtualId) {
                carregarCaminhoes(moldagemAtualId);
              }
            }, [moldagemAtualId]);

            function novoEnsaio() {
            setForm(estadoInicial);
            setEnsaioEditando(null);
            setClienteSelecionado(null);
            setPesquisaCliente("");
            setOpenDialog(true);
          }

              async function novoEnsaioDentroObra() {
                  // 🔥 buscar dados da obra no Firestore
                  let snap = null;
                  let rupturaExternaPadrao = false;

if (obraSelecionadaId) {
  snap = await getDoc(doc(db, "obras", obraSelecionadaId));

  if (snap.exists()) {
    const obraData = snap.data();
    rupturaExternaPadrao = obraData.rupturaExternaPadrao === true;

    if (obraData.codigoInicial === undefined) {
      setMostrarInputCodigo(true);
    } else {
      setMostrarInputCodigo(false);
    }
  } else {
    setMostrarInputCodigo(true);
  }
} else {
  setMostrarInputCodigo(true);
}
                  

                  let clienteNome = "";
                  let clienteId = null;
                  let obraNome = obraSelecionada;
                  let responsavelProducaoConcreto = "";

                  if (snap.exists()) {
                    const obraData = snap.data();
                    clienteNome = obraData.cliente || "";
                    clienteId = obraData.clienteId || null;
                    obraNome = obraData.nome || obraSelecionada;
                    responsavelProducaoConcreto = obraData.responsavelProducaoConcreto || "";
                  }

                  // 🔥 setar cliente selecionado corretamente
                  const clienteObj = clientes.find(c => c.id === clienteId) || null;

                  setClienteSelecionado(clienteObj);

                  // 🔥 carregar obras do cliente (pra liberar select)
                  if (clienteId) {
                    await carregarObrasPorCliente(clienteId);
                  }

                  setForm({
                    ...estadoInicial,
                    cliente: clienteNome,
                    clienteId: clienteId,
                    obra: obraNome,
                    obraId: obraSelecionadaId,
                    concreteira: responsavelProducaoConcreto,
                    rupturaExterna: rupturaExternaPadrao,
                    responsavelMoldagem: rupturaExternaPadrao ? "construtora" : estadoInicial.responsavelMoldagem,
                    moldador: rupturaExternaPadrao ? "N/I" : estadoInicial.moldador,
                    prensaRuptura: rupturaExternaPadrao ? null : estadoInicial.prensaRuptura
                  });

                  setEnsaioEditando(null);
                  setOpenDialog(true);
                }

          function handleEnterCP(e, rowIndex, idadeIndex, cpIndex) {
                if (e.key !== "Enter") return;

                e.preventDefault();

                let nextPos;

                // CP1 -> CP2 do mesmo caminhão
                if (cpIndex === 0) {
                  nextPos = `${rowIndex}-${idadeIndex}-1`;
                } 
                // CP2 -> CP1 do próximo caminhão na mesma idade
                else {
                  nextPos = `${rowIndex + 1}-${idadeIndex}-0`;
                }

                const next = document.querySelector(
                  `input[data-pos='${nextPos}']:not(:disabled)`
                );

                if (next) {
                  next.focus();
                  next.select?.();
                }
              }

function handleEnterColuna(e, coluna) {
  if (e.key === "Enter") {
    e.preventDefault();

    const inputs = Array.from(
      document.querySelectorAll(`input[data-col='${coluna}']`)
    );

    const index = inputs.indexOf(e.target);

    if (index > -1 && index < inputs.length - 1) {
      inputs[index + 1].focus();
    }
  }
}

function handleEnterDialogMoldagem(event) {
  if (event.key !== "Enter") return;

  const alvo = event.target;
  if (!alvo || alvo.tagName === "TEXTAREA") return;
  if (!alvo.closest?.("[data-moldagem-dialog-container='true']")) return;

  event.preventDefault();

  const campos = Array.from(
    document.querySelectorAll(
      "[data-moldagem-dialog-container='true'] input:not(:disabled):not([readonly]), [data-moldagem-dialog-container='true'] textarea:not(:disabled):not([readonly])"
    )
  ).filter((campo) => {
    const rect = campo.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  });
  const index = campos.indexOf(alvo);

  if (index > -1 && index < campos.length - 1) {
    campos[index + 1].focus();
    campos[index + 1].select?.();
  }
}

          async function abrirEdicaoDireta(item) {

              setFiltroPrensaExterna(
                item.rupturaExterna === true
                  ? obterFiltroPrensaSalva(
                      item.prensaRuptura,
                      item.obra,
                      item.cliente
                    )
                  : "obra"
              );

              setForm({
                cliente: item.cliente || "",
                clienteId: item.clienteId || null,
                obra: item.obra || "",
                obraId: item.obraId || null,
                datamoldagem: item.datamoldagem || "",
                inicioConcretagem: item.inicioConcretagem || "",
                terminoConcretagem: item.terminoConcretagem || "",
                moldador: item.moldador || "",
                concreteira: item.concreteira || "",
                responsavelMoldagem: item.responsavelMoldagem || "",
                rupturaExterna: item.rupturaExterna === true,
                prensaRuptura: item.prensaRuptura || null,
                incluirObservacaoRelatorio: item.incluirObservacaoRelatorio === true,
                observacaoRelatorio: item.observacaoRelatorio || "",
                nomeTraco: item.nomeTraco || "",
                fckProjeto: item.fckProjeto || "",
                slumpProjeto: item.slumpProjeto || "",
                toleranciaSlumpProjeto: item.toleranciaSlumpProjeto || "",
                tipoLancamento: item.tipoLancamento || "",
                tipoCapeamento: item.tipoCapeamento || "",
                tipoAreaCp: item.tipoAreaCp || "10x20",
                areaCp: item.areaCp || 7854,
                qtdCaminhoes: item.qtdCaminhoes || "",
                qtdIdades: item.idades?.length || 0,
                idades: item.idades || []
              });

              const clienteEncontrado = clientes.find(
                c => c.id === item.clienteId
              );

              setClienteSelecionado(clienteEncontrado || null);

              // 🔥 ESSA LINHA ESTAVA FALTANDO
              if (item.clienteId) {
                await carregarObrasPorCliente(item.clienteId);
              }

                 let snapObra = null;

if (item.obraId) {
  snapObra = await getDoc(doc(db, "obras", item.obraId));

  if (snapObra.exists()) {
    const obraData = snapObra.data();
    setObraDados(obraData);
    setMostrarInputCodigo(
  obraData.codigoInicial === undefined ||
  obraData.codigoInicialCaminhao === undefined
);
  } else {
    setObraDados(null);
    setMostrarInputCodigo(true);
  }
} else {
  setObraDados(null);
  setMostrarInputCodigo(true);
}


              setMoldagemAtualId(item.id);
              setEnsaioEditando(item);
              setOpenDialog(true);
            }           



  const modoEdicao = !!ensaioEditando;


          function atualizarCampoLocal(caminhaoId, campo, valor) {

          setEnsaios(prev => {
            const index = prev.findIndex(i => i.id === caminhaoId);
            if (index === -1) return prev;

            const item = prev[index];

            if (item.status === "cancelado") return prev;

            const novoItem = { ...item, [campo]: valor };

            const novaLista = [...prev];
            novaLista[index] = novoItem;

            return novaLista;
          });

          setTemAlteracao(true);
        }

async function carregarObrasPorCliente(clienteId) {
  if (!clienteId) {
    setObrasSistema([]);
    return;
  }

  const q = query(
    collection(db, "obras"),
    where("clienteId", "==", clienteId),
    orderBy("nome", "asc")
  );

  const snapshot = await getDocs(consultaTenantAtual(q));

  const lista = await Promise.all(
  snapshot.docs.map(async (docSnap) => {

    const data = docSnap.data();

    // 🔥 buscar caminhões
    return {
  id: docSnap.id,
  ...data
    };
  })
);

  setObrasSistema(lista.filter(obraEstaAtiva));
}

async function abrirMoldagem(item) {

  let moldagemAtualizada = item;

  if (item?.id) {
    const snapMoldagem = await getDoc(doc(db, "tblAgendaRuptura", item.id));

    if (snapMoldagem.exists()) {
      moldagemAtualizada = {
        id: item.id,
        ...snapMoldagem.data()
      };
    }
  }

  const formMoldagem = {
  cliente: moldagemAtualizada.cliente || "",
  clienteId: moldagemAtualizada.clienteId || null,
  obra: moldagemAtualizada.obra || "",
  obraId: moldagemAtualizada.obraId || null,
  datamoldagem: moldagemAtualizada.datamoldagem || "",
  inicioConcretagem: moldagemAtualizada.inicioConcretagem || "",
  terminoConcretagem: moldagemAtualizada.terminoConcretagem || "",
  moldador: moldagemAtualizada.moldador || "",
  concreteira: moldagemAtualizada.concreteira || "",
   responsavelMoldagem: moldagemAtualizada.responsavelMoldagem || "concreto_engenharia",
  rupturaExterna: moldagemAtualizada.rupturaExterna === true,
  prensaRuptura: moldagemAtualizada.prensaRuptura || null,
  incluirObservacaoRelatorio:
    moldagemAtualizada.incluirObservacaoRelatorio === true,
  observacaoRelatorio: moldagemAtualizada.observacaoRelatorio || "",
  fckProjeto: moldagemAtualizada.fckProjeto || "",
  slumpProjeto: moldagemAtualizada.slumpProjeto || "",
  toleranciaSlumpProjeto: moldagemAtualizada.toleranciaSlumpProjeto || "",
  tipoLancamento: moldagemAtualizada.tipoLancamento || "",
  qtdCaminhoes: moldagemAtualizada.qtdCaminhoes || "",
  qtdIdades: moldagemAtualizada.idades?.length || 0,
  idades: moldagemAtualizada.idades || [],
  datasRuptura: moldagemAtualizada.datasRuptura || []
};

  setFiltroPrensaExterna(
    moldagemAtualizada.rupturaExterna === true
      ? obterFiltroPrensaSalva(
          moldagemAtualizada.prensaRuptura,
          moldagemAtualizada.obra,
          moldagemAtualizada.cliente
        )
      : "obra"
  );
  setForm(formMoldagem);

  setMoldagemAtualId(moldagemAtualizada.id);


  let snapObra = null;

if (moldagemAtualizada.obraId) {
  snapObra = await getDoc(doc(db, "obras", moldagemAtualizada.obraId));

  if (snapObra.exists()) {
    const obraData = snapObra.data();
    setObraDados(obraData);
    setMostrarInputCodigo(
  obraData.codigoInicial === undefined ||
  obraData.codigoInicialCaminhao === undefined
);
  } else {
    setObraDados(null);
    setMostrarInputCodigo(true);
  }
} else {
  setObraDados(null);
  setMostrarInputCodigo(true);
}

  const caminhoes = await carregarCaminhoes(moldagemAtualizada.id);
  const moldagemComCaminhoes = {
    ...moldagemAtualizada,
    caminhoes
  };

  setEstadoOriginalEdicao(clonarDados({
    form: formMoldagem,
    ensaios: caminhoes,
    moldagemSelecionada: moldagemComCaminhoes
  }));
  setTemAlteracao(false);
  setOpenConfirmarCancelamento(false);

  return moldagemComCaminhoes;

}

async function visualizarMoldagem(item, imprimirAutomaticamente = false) {
  try {
    setAbrindoMoldagem(true);

    const moldagemAtualizada = await abrirMoldagem(item);

    setMoldagemSelecionada(moldagemAtualizada || item);
    setAutoPrint(imprimirAutomaticamente);
    setVisualizacaoVeioDaLista(true);
    setModoPrint(true);
  } finally {
    setAbrindoMoldagem(false);
  }
}

useEffect(() => {
  if (!moldagemId) return;

  async function abrirMoldagemDaRota() {
    const snap = await getDoc(doc(db, "tblAgendaRuptura", moldagemId));
    if (!snap.exists()) {
      history.replace("/app/agendamoldagem");
      return;
    }

    const moldagem = { id: snap.id, ...snap.data() };
    setObraSelecionada(moldagem.obra || null);
    setObraSelecionadaId(moldagem.obraId || null);
    setPesquisaMoldagem("");

    const moldagemAtualizada = await abrirMoldagem(moldagem);
    setMoldagemSelecionada(moldagemAtualizada || moldagem);
  }

  abrirMoldagemDaRota();
}, [moldagemId]);

function voltarTelaAnterior() {

  // 🔥 SE ESTIVER NA LISTA DE OBRAS → VOLTA PARA TELA ANTERIOR DO SISTEMA
  if (!obraSelecionada && !moldagemSelecionada && !modoPrint) {
    history.goBack();
    return;
  }

  if (somenteLeitura && voltarParaLaudos) {
    history.push("/app/laudos");
    return;
  }

  if (modoPrint) {
  setModoPrint(false);
  setAutoPrint(false);

  // 🔥 GARANTE VOLTAR PARA LISTA DA OBRA
  setMoldagemSelecionada(null);

  return;
}

  if (moldagemSelecionada) {
    setMoldagemSelecionada(null);
    setMoldagemAtualId(null);
    setEnsaioEditando(null);
    setOpenDialog(false);
    setEnsaios([]);
    if (moldagemId) {
      history.push("/app/agendamoldagem");
    }
    return;
  }

  if (obraSelecionada) {
    setObraSelecionada(null);
    setObraSelecionadaId(null);
    setListaMoldagens([]);
    setListaMoldagensNumeracao([]);
    setUltimaMoldagemDoc(null);
    setTemMaisMoldagens(false);
    return;
  }
}

function campoCargaPreenchido(valor) {
  return valor !== null && valor !== undefined && String(valor).trim() !== "";
}

function cargaMarcadaComoNaoAplicavel(valor) {
  return String(valor ?? "").trim() === "-";
}

function cargaNumericaPreenchida(valor) {
  return !cargaMarcadaComoNaoAplicavel(valor) && parseDecimal(valor) !== null;
}

function normalizarCargaParaSalvar(valor) {
  return cargaMarcadaComoNaoAplicavel(valor) ? "-" : parseDecimal(valor);
}

function obterIdadesSemCargaLancada(moldagem) {
  const idades = Array.isArray(moldagem?.idades) ? moldagem.idades : [];
  const caminhoes = Array.isArray(moldagem?.caminhoes) ? moldagem.caminhoes : [];

  if (!idades.length) return [];

  return idades
    .map((idade, idadeIndex) => {
      const possuiCarga = caminhoes.some((caminhao) => {
        if (caminhao.status === "cancelado") return false;

        const resultado = caminhao.resultados?.[idadeIndex];

        return (
          campoCargaPreenchido(resultado?.cp1) ||
          campoCargaPreenchido(resultado?.cp2)
        );
      });

      if (possuiCarga) return null;

      const valorIdade = String(idade?.dias || "").trim();

      if (!valorIdade) return `Idade ${idadeIndex + 1}`;

      return isNaN(Number(valorIdade))
        ? valorIdade
        : `${valorIdade} dias`;
    })
    .filter(Boolean);
}

function moldagemTemIdadeSemCargaLancada(moldagem) {
  return obterIdadesSemCargaLancada(moldagem).length > 0;
}

function existeCargaRupturaDigitada() {
  return ensaios.some((ensaio) => {
    if (ensaio.status === "cancelado") return false;

    return (ensaio.resultados || []).some((resultado) =>
      cargaNumericaPreenchida(resultado?.cp1) || cargaNumericaPreenchida(resultado?.cp2)
    );
  });
}

function preencherPrensaVinculadaAoDigitarCarga(valor) {
  if (!cargaNumericaPreenchida(valor)) return;

  const prensaPadrao = obraDados?.prensaRupturaPadrao;
  if (!prensaPadrao?.id) return;

  setForm((anterior) =>
    anterior.prensaRuptura?.id
      ? anterior
      : { ...anterior, prensaRuptura: prensaPadrao }
  );
}

function fecharAvisoPrensa() {
  setOpenAvisoPrensa(false);
}

function solicitarCancelarAlteracoes() {
  setNavegacaoPendente(null);
  setOpenConfirmarCancelamento(true);
}

function confirmarCancelarAlteracoes() {
  if (estadoOriginalEdicao) {
    setForm(clonarDados(estadoOriginalEdicao.form));
    setEnsaios(clonarDados(estadoOriginalEdicao.ensaios) || []);
    setMoldagemSelecionada(clonarDados(estadoOriginalEdicao.moldagemSelecionada));
  }

  setTemAlteracao(false);
  setOpenConfirmarCancelamento(false);

  if (navegacaoPendente) {
    const destino = `${navegacaoPendente.pathname}${navegacaoPendente.search || ""}${navegacaoPendente.hash || ""}`;
    desbloquearNavegacaoRef.current?.();
    desbloquearNavegacaoRef.current = null;
    setNavegacaoPendente(null);
    history.push(destino);
  }
}



async function salvarAlteracoes() {

  if (!moldagemAtualId) return;

  if (form.prensaRuptura?.id && !existeCargaRupturaDigitada()) {
    setMensagemAvisoPrensa(
      "Não foi identificado cargas de ruptura para a prensa selecionada."
    );
    setOpenAvisoPrensa(true);
    return;
  }

  if (existeCargaRupturaDigitada() && !form.prensaRuptura?.id) {
    setMensagemAvisoPrensa(
      "É necessário selecionar a prensa utilizada na ruptura antes de salvar."
    );
    setOpenAvisoPrensa(true);
    return;
  }

  try {

    setSalvando(true);
    const ensaiosFormatados = normalizarEnsaiosDecimais(ensaios);
    setEnsaios(ensaiosFormatados);

    const promises = ensaiosFormatados.map(item =>
      updateDoc(
        doc(
          db,
          "tblAgendaRuptura",
          moldagemAtualId,
          "caminhoes",
          item.id
        ),
        {
            notaFiscalRomaneio: item.notaFiscalRomaneio || "",
qtd: parseDecimal(item.qtd),
slumpObtido: parseDecimal(item.slumpObtido),
            pecaConcretada: item.pecaConcretada || "",
            observacoes: item.observacoes || "",
            moduloElasticidade: item.moduloElasticidade === true,
            resultados: (item.resultados || []).map(r => ({
              cp1: normalizarCargaParaSalvar(r?.cp1),
              cp2: normalizarCargaParaSalvar(r?.cp2)
            }))
          }
      )
    );

    await Promise.all(promises);

    await updateDoc(
      doc(db, "tblAgendaRuptura", moldagemAtualId),
      {
        prensaRuptura: form.prensaRuptura || null,
        incluirObservacaoRelatorio: form.incluirObservacaoRelatorio === true,
        observacaoRelatorio: form.incluirObservacaoRelatorio
          ? form.observacaoRelatorio || ""
          : ""
      }
    );

    await registrarAlteracaoAgendaRuptura(
      form.obraId || moldagemSelecionada?.obraId
    );

    setMoldagemSelecionada((anterior) =>
      anterior
        ? {
            ...anterior,
            prensaRuptura: form.prensaRuptura || null,
            incluirObservacaoRelatorio:
              form.incluirObservacaoRelatorio === true,
            observacaoRelatorio: form.incluirObservacaoRelatorio
              ? form.observacaoRelatorio || ""
              : ""
          }
        : anterior
    );

    setListaMoldagens((anterior) =>
      anterior.map((moldagem) =>
        moldagem.id === moldagemAtualId
          ? {
              ...moldagem,
              prensaRuptura: form.prensaRuptura || null,
              incluirObservacaoRelatorio:
                form.incluirObservacaoRelatorio === true,
              observacaoRelatorio: form.incluirObservacaoRelatorio
                ? form.observacaoRelatorio || ""
                : ""
            }
          : moldagem
      )
    );

    const detalhes = ensaiosFormatados
  .map((c, index) => `Caminhão ${index + 1}`)
  .join(", ");

await registrarHistorico(
  "ALTERACAO_CAMINHAO",
  `Alterações realizadas em: ${detalhes}`
);

    const moldagemAtualizadaEdicao = moldagemSelecionada
      ? {
          ...moldagemSelecionada,
          prensaRuptura: form.prensaRuptura || null,
          incluirObservacaoRelatorio:
            form.incluirObservacaoRelatorio === true,
          observacaoRelatorio: form.incluirObservacaoRelatorio
            ? form.observacaoRelatorio || ""
            : "",
          caminhoes: ensaiosFormatados
        }
      : null;

    if (moldagemAtualizadaEdicao) {
      setMoldagemSelecionada(moldagemAtualizadaEdicao);
    }

    setEstadoOriginalEdicao(clonarDados({
      form,
      ensaios: ensaiosFormatados,
      moldagemSelecionada: moldagemAtualizadaEdicao
    }));
    setTemAlteracao(false);
    await carregarMoldagensDaObra();
    setMoldagemSelecionada(null);
    setMoldagemAtualId(null);
    setEnsaioEditando(null);
    setOpenDialog(false);
    setEnsaios([]);
        
      } catch (error) {
        console.error(error);
      } finally {
        setSalvando(false);
      }
    } 
      function calcularDatasRuptura(dataMoldagem, idades) {
  if (!dataMoldagem || !idades) return [];

  const [ano, mes, dia] = dataMoldagem.split("-");

  return idades.map(i => {
    const diasNumero = Number(i.dias);

    // 🔥 SE NÃO FOR NÚMERO → RETORNA NULL
    if (isNaN(diasNumero)) {
      return null;
    }

    const base = new Date(ano, mes - 1, dia);
    base.setDate(base.getDate() + diasNumero);

    return base.toISOString().split("T")[0];
  });
}

async function confirmarPrensaVencidaAoDigitarCarga(valor, idadeIndex) {
  if (!cargaNumericaPreenchida(valor)) return true;

  const prensa =
    form.prensaRuptura ||
    obraDados?.prensaRupturaPadrao;

  if (prensa?.calibracaoExterna === true) return true;

  const dataRuptura =
    calcularDatasRuptura(
      form.datamoldagem,
      form.idades
    )[idadeIndex];

  const dataVencimento =
    obterDataVencimentoPrensaISO(prensa);

  if (
    !prensa?.id ||
    !dataRuptura ||
    !dataVencimento ||
    dataRuptura <= dataVencimento
  ) {
    return true;
  }

  const chaveConfirmacao =
    `${prensa.id}-${dataRuptura}`;

  if (
    confirmacoesPrensaVencidaRef.current.has(
      chaveConfirmacao
    )
  ) {
    return true;
  }

  const confirmou = await confirmarSistema(
    `Esta prensa está com o certificado vencido para a ruptura de ${formatarDataBR(dataRuptura)}. ` +
    `O certificado venceu em ${formatarDataBR(dataVencimento)}. Deseja salvar assim mesmo?`,
    {
      titulo: "Certificado da prensa vencido",
      textoConfirmar: "Salvar assim mesmo",
      textoCancelar: "Cancelar",
    }
  );

  if (confirmou) {
    confirmacoesPrensaVencidaRef.current.add(
      chaveConfirmacao
    );
  }

  return confirmou;
}


  /* =========================
     SALVAR
  ========================= */
  async function salvarEnsaio(abrirAposSalvar = false) {
  if (!String(form.datamoldagem || "").trim()) {
    setErroDataMoldagem(true);
    alert("Informe a data da moldagem.");
    return;
  }

  setErroDataMoldagem(false);

  if (!String(form.moldador || "").trim()) {
    alert("Informe o Moldador ou marque N/I (Não informado).");
    return;
  }

  try {
    setSalvando(true);

    // 🔵 MODO EDIÇÃO
    if (modoEdicao && moldagemAtualId) {

  const novaQuantidade = Number(form.qtdCaminhoes);
  const caminhoesSnap = await getDocs(
    collection(db, "tblAgendaRuptura", moldagemAtualId, "caminhoes")
  );
  const quantidadeCaminhoesCadastrados = caminhoesSnap.size;
  const possuiCaminhoesCadastrados = !caminhoesSnap.empty;
  const quantidadeAnterior = Number(
    ensaioEditando?.qtdCaminhoes || quantidadeCaminhoesCadastrados
  );

  const caminhoesCadastrados = caminhoesSnap.docs
    .map((documento) => ({
      id: documento.id,
      ...documento.data()
    }))
    .sort((a, b) => {
      const codigoA = Number(a.cod_caminhao);
      const codigoB = Number(b.cod_caminhao);
      const ordemA = Number.isFinite(codigoA) && codigoA > 0
        ? codigoA
        : Number.MAX_SAFE_INTEGER;
      const ordemB = Number.isFinite(codigoB) && codigoB > 0
        ? codigoB
        : Number.MAX_SAFE_INTEGER;

      return ordemA - ordemB || a.id.localeCompare(b.id);
    });

  const maiorCodigoCadastrado = caminhoesCadastrados.reduce((maior, caminhao) => {
    const codigo = Number(caminhao.cod_caminhao);
    return Number.isFinite(codigo) && codigo > maior ? codigo : maior;
  }, 0);
  const caminhoesSemCodigo = caminhoesCadastrados.filter((caminhao) => {
    const codigo = Number(caminhao.cod_caminhao);
    return !Number.isFinite(codigo) || codigo <= 0;
  });

  await Promise.all(
    caminhoesSemCodigo.map((caminhao, index) =>
      updateDoc(
        doc(
          db,
          "tblAgendaRuptura",
          moldagemAtualId,
          "caminhoes",
          caminhao.id
        ),
        { cod_caminhao: maiorCodigoCadastrado + index + 1 }
      )
    )
  );

  const maiorCodigoAposCorrecao = maiorCodigoCadastrado + caminhoesSemCodigo.length;

  if (possuiCaminhoesCadastrados && novaQuantidade < quantidadeAnterior) {
    const caminhoesExcedentes = caminhoesCadastrados.slice(novaQuantidade);
    const possuiDadosNosExcedentes = caminhoesExcedentes.some(
      caminhaoPossuiDados
    );

    if (possuiDadosNosExcedentes) {
      alert("Quantidade menor só pode ser reduzida cancelando caminhões na lista.");
      setSalvando(false);
      return;
    }

    await Promise.all(
      caminhoesExcedentes.map((caminhao) =>
        deleteDoc(
          doc(
            db,
            "tblAgendaRuptura",
            moldagemAtualId,
            "caminhoes",
            caminhao.id
          )
        )
      )
    );
  }

  // 🔺 Se aumentar
  if (
    possuiCaminhoesCadastrados &&
    novaQuantidade > quantidadeCaminhoesCadastrados
  ) {

    const promises = [];

    const quantidadeNovosCaminhoes = novaQuantidade - quantidadeCaminhoesCadastrados;

    for (let i = 1; i <= quantidadeNovosCaminhoes; i++) {
      promises.push(
        addDoc(
          collection(db, "tblAgendaRuptura", moldagemAtualId, "caminhoes"),
          {
              cod_caminhao: maiorCodigoAposCorrecao + i,
              notaFiscalRomaneio: "",
              qtd: "",
              slumpObtido: "",
              pecaConcretada: "",
              observacoes: "",
              moduloElasticidade: false,
              status: "ativo"
            }
        )
      );
    }

    await Promise.all(promises);
  }
const datasRuptura = calcularDatasRuptura(
  form.datamoldagem,
  form.idades
);

const obraIdParaSalvar = form.obraId;

if (!obraIdParaSalvar) {
  alert("Obra não identificada");
  setSalvando(false);
  return;
}

if (exibirCamposCodigoInicial && mostrarInputCodigo && (!codigoInicialInput || !codigoInicialCaminhaoInput)) {
  alert("Informe o código inicial da obra");
  setSalvando(false);
  return;
}

if (codigoInicialInput) {
  await updateDoc(doc(db, "obras", obraIdParaSalvar), {
    codigoInicial: Number(codigoInicialInput),
codigoInicialCaminhao: Number(codigoInicialCaminhaoInput || 0)
  });
}

  // Atualiza documento principal
 await updateDoc(
  doc(db, "tblAgendaRuptura", moldagemAtualId),
  {
    cliente: clienteSelecionado?.nome || "",
    clienteId: clienteSelecionado?.id || null,
    obra: form.obra || "",
    obraId: form.obraId || null,
    datamoldagem: form.datamoldagem || "",
    inicioConcretagem: form.inicioConcretagem || "",
    terminoConcretagem: form.terminoConcretagem || "",
    moldador: form.moldador || "",
    concreteira: form.concreteira || "",
    responsavelMoldagem: form.responsavelMoldagem || "",
    rupturaExterna: form.rupturaExterna === true,
    prensaRuptura: form.prensaRuptura || null,
    incluirObservacaoRelatorio: form.incluirObservacaoRelatorio === true,
    observacaoRelatorio: form.incluirObservacaoRelatorio
      ? form.observacaoRelatorio || ""
      : "",
    nomeTraco: form.nomeTraco || "",
    fckProjeto: form.fckProjeto || "",
    slumpProjeto: form.slumpProjeto || "",
    toleranciaSlumpProjeto: form.toleranciaSlumpProjeto || "",
    tipoAreaCp: form.tipoAreaCp,
    areaCp: form.tipoAreaCp === "10x20"
  ? 7854
  : Number(form.areaCp),
    tipoCapeamento: form.tipoCapeamento || "",
    tipoLancamento: form.tipoLancamento || "",
    datasRuptura: datasRuptura,
    qtdCaminhoes: novaQuantidade,
    idades: form.idades || []
  }
);
  await registrarAlteracaoAgendaRuptura(obraIdParaSalvar);

  await registrarHistorico(
  "ALTERACAO_MOLDAGEM",
  "Dados gerais da moldagem foram alterados."
);


  await carregarCaminhoes(moldagemAtualId);
  await carregarMoldagensDaObra();

  setEnsaioEditando(null);
  setOpenDialog(false);
  return;
}


    // 🟢 NOVO CADASTRO
    if (!clienteSelecionado) {
  alert("Selecione um cliente.");
  setSalvando(false);
  return;
}

if (!form.obra || !form.qtdCaminhoes) {
  alert("Preencha os campos obrigatórios.");
  setSalvando(false);
  return;
}
  const datasRuptura = calcularDatasRuptura(
    form.datamoldagem,
    form.idades
  );
        const obraIdParaSalvar = form.obraId;

if (!obraIdParaSalvar) {
  alert("Selecione a obra antes de salvar o código inicial");
  setSalvando(false);
  return;
}

if (exibirCamposCodigoInicial && mostrarInputCodigo && (!codigoInicialInput || !codigoInicialCaminhaoInput)) {
  alert("Informe o código inicial da obra");
  setSalvando(false);
  return;
}

if (codigoInicialInput) {
  console.log("SALVANDO CODIGO NA OBRA:", obraIdParaSalvar);

await updateDoc(doc(db, "obras", obraIdParaSalvar), {
  codigoInicial: Number(codigoInicialInput),
codigoInicialCaminhao: Number(codigoInicialCaminhaoInput || 0)
});

  setObraDados(prev => ({
    ...prev,
    codigoInicial: Number(codigoInicialInput)
  }));
}


const docRef = await addDoc(collection(db, "tblAgendaRuptura"), aplicarTenantAtual({
  cliente: clienteSelecionado?.nome || "",
  clienteId: clienteSelecionado?.id || null,
  obra: form.obra || "",
  obraId: form.obraId || null,
  datamoldagem: form.datamoldagem || "",
  inicioConcretagem: form.inicioConcretagem || "",
  terminoConcretagem: form.terminoConcretagem || "",
  moldador: form.moldador || "",
  concreteira: form.concreteira || "",
  responsavelMoldagem: form.responsavelMoldagem || "",
  rupturaExterna: form.rupturaExterna === true,
  prensaRuptura: form.prensaRuptura || null,
  incluirObservacaoRelatorio: form.incluirObservacaoRelatorio === true,
  observacaoRelatorio: form.incluirObservacaoRelatorio
    ? form.observacaoRelatorio || ""
    : "",
  nomeTraco: form.nomeTraco || "",
  fckProjeto: form.fckProjeto || "",
  slumpProjeto: form.slumpProjeto || "",
  toleranciaSlumpProjeto: form.toleranciaSlumpProjeto || "",
  datasRuptura: datasRuptura,
  tipoAreaCp: form.tipoAreaCp,
  areaCp: form.tipoAreaCp === "10x20"
  ? 7854
  : Number(form.areaCp),
  tipoCapeamento: form.tipoCapeamento || "",
  tipoLancamento: form.tipoLancamento || "",
  qtdCaminhoes: form.qtdCaminhoes,
  idades: form.idades || [],
  criadoEm: new Date()
}));
// 🔥 REGISTRAR HISTÓRICO DE CRIAÇÃO
await addDoc(
  collection(db, "tblAgendaRuptura", docRef.id, "historico"),
  {
    usuario: auth.currentUser?.email || "Usuário desconhecido",
    uid: auth.currentUser?.uid || null,
    data: new Date(),
    tipo: "",
    descricao: `Moldagem criada com ${form.qtdCaminhoes} caminhões.`
  }
);

// CRIAR CAMINHÕES
const promises = [];

for (let i = 1; i <= Number(form.qtdCaminhoes); i++) {
  promises.push(
    addDoc(
      collection(db, "tblAgendaRuptura", docRef.id, "caminhoes"),
      {
        cod_caminhao: i,
        notaFiscalRomaneio: "",
        qtd: "",
        slumpObtido: "",
        pecaConcretada: "",
        observacoes: "",
        moduloElasticidade: false,
        resultados: [],
        status: "ativo"
      }
    )
  );
}

await Promise.all(promises);

await registrarAlteracaoAgendaRuptura(obraIdParaSalvar);
await carregarMoldagensDaObra();
setOpenDialog(false);

if (abrirAposSalvar) {
  const moldagemCriada = {
    id: docRef.id,
    cliente: clienteSelecionado?.nome || "",
    clienteId: clienteSelecionado?.id || null,
    obra: form.obra || "",
    obraId: form.obraId || null,
    datamoldagem: form.datamoldagem || "",
    inicioConcretagem: form.inicioConcretagem || "",
    terminoConcretagem: form.terminoConcretagem || "",
    moldador: form.moldador || "",
    concreteira: form.concreteira || "",
    responsavelMoldagem: form.responsavelMoldagem || "",
    rupturaExterna: form.rupturaExterna === true,
    prensaRuptura: form.prensaRuptura || null,
    incluirObservacaoRelatorio: form.incluirObservacaoRelatorio === true,
    observacaoRelatorio: form.incluirObservacaoRelatorio
      ? form.observacaoRelatorio || ""
      : "",
    nomeTraco: form.nomeTraco || "",
    fckProjeto: form.fckProjeto || "",
    slumpProjeto: form.slumpProjeto || "",
    toleranciaSlumpProjeto: form.toleranciaSlumpProjeto || "",
    datasRuptura,
    tipoAreaCp: form.tipoAreaCp,
    areaCp: form.tipoAreaCp === "10x20" ? 7854 : Number(form.areaCp),
    tipoCapeamento: form.tipoCapeamento || "",
    tipoLancamento: form.tipoLancamento || "",
    qtdCaminhoes: form.qtdCaminhoes,
    idades: form.idades || []
  };

  const moldagemAtualizada = await abrirMoldagem(moldagemCriada);
  setMoldagemSelecionada(moldagemAtualizada || moldagemCriada);
}


  } catch (error) {
    console.error(error);
    alert("Erro ao salvar.");
  } finally {
    setSalvando(false);
  }
}



  const campoBox = {
    border: "1px solid #e0e0e0",
    borderRadius: 1,
    padding: "5px 10px",
   // padding: "8px 10px",
    minHeight: 60,
    minWidth: 130,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: "#555",
  };

  const valorStyle = {
    fontSize: 14,
    fontWeight: 500,
    minHeight: 18
  };

  function handleEnter(e, campo) {
  if (e.key === "Enter") {
    e.preventDefault();

    const inputs = Array.from(
      document.querySelectorAll(`input[data-field='${campo}']:not(:disabled)`)
    );

    const inputAtual = e.currentTarget?.querySelector?.("input") || e.target;
    const index = inputs.indexOf(inputAtual);

    if (index > -1 && index < inputs.length - 1) {
      inputs[index + 1].focus();
      inputs[index + 1].select?.();
    }
  }
}
async function carregarObrasAgenda(page = paginaObrasAgenda) {
  const user = auth.currentUser;
  if (!user) return;

  try {
    setCarregandoObrasAgenda(true);
    const tipoUsuario = (localStorage.getItem("tipoUsuario") || "").toLowerCase();
    if (tipoUsuario === "cliente") {
      const userDoc = await getDoc(doc(db, "users", user.uid));
      const obrasDoUsuario = userDoc.data()?.obras || [];

      if (obrasDoUsuario.length === 0) {
        setListaObrasAgenda([]);
        setPaginasObrasAgenda(1);
        return;
      }

      const docsObras = await Promise.all(
        obrasDoUsuario.map((obraId) => getDoc(doc(db, "obras", obraId)))
      );

      const lista = docsObras
        .filter((snap) => snap.exists())
        .map((snap) => ({ id: snap.id, ...snap.data() }))
        .filter(obraEstaAtiva)
        .sort((a, b) => (a.nome || "").localeCompare(b.nome || ""));
      const listaComAgenda = await marcarObrasComMoldagemAgenda(lista);
      const listaFiltrada = listaComAgenda.filter(obraPassaFiltroRelatorio);

      const inicio = page * itensPorPaginaObrasAgenda;
      const fim = inicio + itensPorPaginaObrasAgenda;
      setListaObrasAgenda(listaFiltrada.slice(inicio, fim));
      setPaginasObrasAgenda(Math.max(1, Math.ceil(listaFiltrada.length / itensPorPaginaObrasAgenda)));
      return;
    }

    if (filtroRelatorioObra !== "todos") {
      const snapshot = await getDocs(
        consultaTenantAtual(query(collection(db, "obras"), orderBy("nome", "asc")))
      );
      const lista = snapshot.docs
        .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
        .filter(obraEstaAtiva);
      const listaComAgenda = await marcarObrasComMoldagemAgenda(lista);
      const listaFiltrada = listaComAgenda.filter(obraPassaFiltroRelatorio);
      const inicio = page * itensPorPaginaObrasAgenda;
      const fim = inicio + itensPorPaginaObrasAgenda;

      setListaObrasAgenda(listaFiltrada.slice(inicio, fim));
      setLastDocsObrasAgenda([]);
      setPaginasObrasAgenda(Math.max(1, Math.ceil(listaFiltrada.length / itensPorPaginaObrasAgenda)));
      return;
    }

    const constraints = [orderBy("nome", "asc")];

    if (page > 0 && lastDocsObrasAgenda[page - 1]) {
      constraints.push(startAfter(lastDocsObrasAgenda[page - 1]));
    }

    constraints.push(limit(itensPorPaginaObrasAgenda + 1));

    const snapshot = await getDocs(consultaTenantAtual(query(collection(db, "obras"), ...constraints)));
    const docsPagina = snapshot.docs.slice(0, itensPorPaginaObrasAgenda);
    const temProximaPagina = snapshot.docs.length > itensPorPaginaObrasAgenda;

    const lista = docsPagina.map((docSnap) => {
      const data = docSnap.data();

      return {
        id: docSnap.id,
        ...data
      };
    });
    const listaComAgenda = await marcarObrasComMoldagemAgenda(lista);

    setListaObrasAgenda(listaComAgenda.filter(obraEstaAtiva));
    setLastDocsObrasAgenda((anterior) => {
      const atualizados = [...anterior];
      if (docsPagina.length) atualizados[page] = docsPagina[docsPagina.length - 1];
      return atualizados;
    });
    setPaginasObrasAgenda(temProximaPagina ? page + 2 : page + 1);
  } catch (error) {
    console.error("Erro ao carregar obras da agenda:", error);
    setListaObrasAgenda([]);
    setPaginasObrasAgenda(1);
  } finally {
    setCarregandoObrasAgenda(false);
  }
}

async function carregarObrasAgendaParaBusca() {
  const user = auth.currentUser;
  if (!user) return;

  try {
    setCarregandoObrasAgenda(true);
    const tipoUsuario = (localStorage.getItem("tipoUsuario") || "").toLowerCase();

    if (tipoUsuario === "cliente") {
      const userDoc = await getDoc(doc(db, "users", user.uid));
      const obrasDoUsuario = userDoc.data()?.obras || [];

      if (obrasDoUsuario.length === 0) {
        setObrasAgendaBusca([]);
        return;
      }

      const docsObras = await Promise.all(
        obrasDoUsuario.map((obraId) => getDoc(doc(db, "obras", obraId)))
      );

      const lista = docsObras
        .filter((snap) => snap.exists())
        .map((snap) => ({ id: snap.id, ...snap.data() }))
        .filter(obraEstaAtiva)
        .sort((a, b) => (a.nome || "").localeCompare(b.nome || ""));

      setObrasAgendaBusca(await marcarObrasComMoldagemAgenda(lista));
      return;
    }

    const snapshot = await getDocs(
      consultaTenantAtual(query(collection(db, "obras"), orderBy("nome", "asc")))
    );

    const lista = snapshot.docs.map((docSnap) => {
        const data = docSnap.data();

        return {
          id: docSnap.id,
          ...data
        };
      }).filter(obraEstaAtiva);

    setObrasAgendaBusca(await marcarObrasComMoldagemAgenda(lista));
  } catch (error) {
    console.error("Erro ao buscar obras da agenda:", error);
    setObrasAgendaBusca([]);
  } finally {
    setCarregandoObrasAgenda(false);
  }
}

async function carregarMoldagensDaObra(page = paginaMoldagens, carregarTudo = false) {
  if (!obraSelecionadaId && !obraSelecionada) {
    setListaMoldagens([]);
    setListaMoldagensNumeracao([]);
    setUltimaMoldagemDoc(null);
    setTemMaisMoldagens(false);
    setPaginasMoldagens(1);
    return;
  }

  try {
    setCarregandoMoldagens(true);

    const filtrosObra = obraSelecionadaId
      ? [where("obraId", "==", obraSelecionadaId)]
      : [where("obra", "==", obraSelecionada)];

    if (page === 0) {
      const snapshotNumeracao = await getDocs(
        consultaTenantAtual(query(collection(db, "tblAgendaRuptura"), ...filtrosObra))
      );

      const moldagensNumeracao = await Promise.all(
        snapshotNumeracao.docs.map(async (docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
          caminhoes: await buscarCaminhoesDaMoldagem(docSnap.id)
        }))
      );

      setListaMoldagensNumeracao(
        moldagensNumeracao.sort(ordenarMoldagensPorNumeracao)
      );
    }

    const partesQuery = [
      collection(db, "tblAgendaRuptura"),
      ...filtrosObra,
      orderBy("datamoldagem", "desc"),
      orderBy("criadoEm", "desc")
    ];

    if (!carregarTudo) {
      if (page > 0 && lastDocsMoldagens[page - 1]) {
        partesQuery.push(startAfter(lastDocsMoldagens[page - 1]));
      }

      partesQuery.push(limit(itensPorPaginaMoldagens + 1));
    }

    const snapshot = await getDocs(consultaTenantAtual(query(...partesQuery)));

    const docsPagina = carregarTudo
      ? snapshot.docs
      : snapshot.docs.slice(0, itensPorPaginaMoldagens);
    const temProximaPagina = !carregarTudo && snapshot.docs.length > itensPorPaginaMoldagens;

    const lista = await Promise.all(
      docsPagina.map(async (docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
        caminhoes: await buscarCaminhoesDaMoldagem(docSnap.id)
      }))
    );

    setListaMoldagens(lista);

    setUltimaMoldagemDoc(
      carregarTudo ? null : docsPagina[docsPagina.length - 1] || null
    );

    setLastDocsMoldagens((anterior) => {
      const atualizados = [...anterior];
      if (!carregarTudo && docsPagina.length) atualizados[page] = docsPagina[docsPagina.length - 1];
      return atualizados;
    });
    setTemMaisMoldagens(temProximaPagina);
    setPaginasMoldagens(temProximaPagina ? page + 2 : page + 1);
  } catch (error) {
    console.error("Erro ao carregar moldagens da obra:", error);
    if (page === 0) {
      setListaMoldagens([]);
      setListaMoldagensNumeracao([]);
      setUltimaMoldagemDoc(null);
      setTemMaisMoldagens(false);
      setPaginasMoldagens(1);
    }
  } finally {
    setCarregandoMoldagens(false);
  }
}

async function carregarMoldagens() {
  const user = auth.currentUser;
  if (!user) return;

  const tipoUsuario = (localStorage.getItem("tipoUsuario") || "").toLowerCase();
  
  // 🔥 CLIENTE: precisa filtrar por obras vinculadas
  if (tipoUsuario === "cliente") {
    try {
      // Busca as obras do cliente
      const userDoc = await getDoc(doc(db, "users", user.uid));
      const obrasDoUsuario = userDoc.data()?.obras || [];
      
      if (obrasDoUsuario.length === 0) {
        setListaMoldagens([]);
        return;
      }
      
      // Firestore permite no máximo 10 valores no operador "in"
      // Se tiver mais de 10 obras, quebra em múltiplas queries
      const chunks = [];
      for (let i = 0; i < obrasDoUsuario.length; i += 10) {
        chunks.push(obrasDoUsuario.slice(i, i + 10));
      }
      
      // Executa uma query para cada chunk
      const promises = chunks.map(chunk => 
        getDocs(consultaTenantAtual(query(
          collection(db, "tblAgendaRuptura"),
          where("obraId", "in", chunk),
          orderBy("datamoldagem", "desc"),
          orderBy("criadoEm", "desc")
        )))
      );
      
      const snapshots = await Promise.all(promises);

const lista = await Promise.all(
  snapshots.flatMap(s => s.docs).map(async (docSnap) => {

    const data = docSnap.data();

    const caminhaoSnap = await getDocs(
      collection(db, "tblAgendaRuptura", docSnap.id, "caminhoes")
    );

    const caminhoes = caminhaoSnap.docs
  .map(d => d.data())
  .sort((a, b) => (a.cod_caminhao || 0) - (b.cod_caminhao || 0));

    return {
      id: docSnap.id,
      ...data,
      caminhoes
    };
  })
);
      
      // Reordena manualmente (já que veio de múltiplas queries)
      lista.sort((a, b) => (b.datamoldagem || "").localeCompare(a.datamoldagem || ""));
      
      setListaMoldagens(lista);
      
    } catch (error) {
      console.error("Erro ao carregar moldagens do cliente:", error);
      setListaMoldagens([]);
    }
    return;
  }
  
  // 🟢 ADMIN / COLABORADOR: vê tudo (sem filtro)
  try {
    const q = query(
      collection(db, "tblAgendaRuptura"),
      orderBy("datamoldagem", "desc"),
      orderBy("criadoEm", "desc")
    );

    const snapshot = await getDocs(consultaTenantAtual(q));

    const lista = await Promise.all(
  snapshot.docs.map(async (docSnap) => {

    const data = docSnap.data();

    const caminhaoSnap = await getDocs(
      collection(db, "tblAgendaRuptura", docSnap.id, "caminhoes")
    );

    const caminhoes = caminhaoSnap.docs.map(d => d.data());

    return {
      id: docSnap.id,
      ...data,
      caminhoes
    };
  })
);

    setListaMoldagens(lista);
  } catch (error) {
    console.error("Erro ao carregar moldagens:", error);
    setListaMoldagens([]);
  }
}

useEffect(() => {
  if (!somenteLeitura || !obraInicialNome) return;

  setObraSelecionada(obraInicialNome);
  setObraSelecionadaId(obraInicialId);
  setPesquisaMoldagem("");
}, [somenteLeitura, obraInicialId, obraInicialNome]);

useEffect(() => {
  if (!obraSelecionada && !obraSelecionadaId) return;

  setListaMoldagens([]);
  setListaMoldagensNumeracao([]);
  setUltimaMoldagemDoc(null);
  setTemMaisMoldagens(false);
  setPaginaMoldagens(0);
  setLastDocsMoldagens([]);
  setPaginasMoldagens(1);
  carregarMoldagensDaObra(0, false);
}, [obraSelecionada, obraSelecionadaId, itensPorPaginaMoldagens]);

useEffect(() => {
  if (!obraSelecionadaId && !obraSelecionada) return;
  if (abrindoMoldagem) return;
  if (moldagemSelecionada || modoPrint) return;

  const pesquisaAtiva = pesquisaMoldagem.trim() !== "";

  carregarMoldagensDaObra(pesquisaAtiva ? 0 : paginaMoldagens, pesquisaAtiva);
}, [
  pesquisaMoldagem,
  paginaMoldagens,
  itensPorPaginaMoldagens,
  obraSelecionadaId,
  obraSelecionada,
  abrindoMoldagem,
  moldagemSelecionada,
  modoPrint
]);


        function formatarDataExtenso(dataISO) {
          if (!dataISO) return "";

          const meses = [
            "janeiro", "fevereiro", "março", "abril", "maio", "junho",
            "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
          ];

          const [ano, mes, dia] = dataISO.split("-");
          return `${Number(dia)} de ${meses[Number(mes) - 1]}, ${ano}`;
        }

    function parseDecimal(valor) {
  if (valor === null || valor === undefined || valor === "") {
    return null;
  }

  if (typeof valor === "number") {
    return valor;
  }

  const numero = parseFloat(valor.replace(",", "."));
  return isNaN(numero) ? null : numero;
}

    function formatarDecimalFixo(valor, casasDecimais) {
      if (valor === null || valor === undefined || valor === "") return "";

      const numero = parseDecimal(valor);
      if (numero === null) return valor;

      return numero.toFixed(casasDecimais).replace(".", ",");
    }

    function formatarQtdM3(valor) {
      return formatarDecimalFixo(valor, 1);
    }

    function formatarCargaTon(valor) {
      return formatarDecimalFixo(valor, 2);
    }

    function formatarQtdParaCampo(valor) {
      return typeof valor === "number" ? formatarQtdM3(valor) : formatarParaExibir(valor);
    }

    function formatarCargaParaCampo(valor) {
      return typeof valor === "number" ? formatarCargaTon(valor) : formatarParaExibir(valor);
    }

    function normalizarEnsaiosDecimais(listaEnsaios) {
      return (listaEnsaios || []).map((item) => ({
        ...item,
        qtd: formatarQtdM3(item.qtd),
        resultados: Array.from(item.resultados || [], (resultado) => ({
          ...resultado,
          cp1: formatarCargaTon(resultado?.cp1),
          cp2: formatarCargaTon(resultado?.cp2)
        }))
      }));
    }

    function formatarQtdLocal(caminhaoId) {
      setEnsaios((prev) =>
        prev.map((item) => {
          if (item.id !== caminhaoId || item.status === "cancelado") return item;
          const valorFormatado = formatarQtdM3(item.qtd);
          return valorFormatado === item.qtd ? item : { ...item, qtd: valorFormatado };
        })
      );
    }

    function formatarCargaLocal(caminhaoId, idadeIndex, campo) {
      setEnsaios((prev) =>
        prev.map((item) => {
          if (item.id !== caminhaoId || item.status === "cancelado") return item;

          const resultados = item.resultados
            ? [...item.resultados]
            : Array(form.idades.length)
                .fill(null)
                .map(() => ({ cp1: "", cp2: "" }));

          if (!resultados[idadeIndex]) resultados[idadeIndex] = { cp1: "", cp2: "" };

          const resultadoAtual = { ...resultados[idadeIndex] };
          const valorFormatado = formatarCargaTon(resultadoAtual[campo]);

          if (valorFormatado === resultadoAtual[campo]) return item;

          resultadoAtual[campo] = valorFormatado;
          resultados[idadeIndex] = resultadoAtual;

          return { ...item, resultados };
        })
      );
    }

    function idadeCaminhaoCancelada(ensaio, idadeIndex) {
      const resultado = ensaio.resultados?.[idadeIndex];
      return cargaMarcadaComoNaoAplicavel(resultado?.cp1) &&
        cargaMarcadaComoNaoAplicavel(resultado?.cp2);
    }

    function alternarCancelamentoIdade(caminhaoId, idadeIndex) {
      setEnsaios((prev) =>
        prev.map((item) => {
          if (item.id !== caminhaoId || item.status === "cancelado") return item;

          const resultados = item.resultados
            ? [...item.resultados]
            : Array(form.idades.length)
                .fill(null)
                .map(() => ({ cp1: "", cp2: "" }));

          const resultadoAtual = resultados[idadeIndex] || { cp1: "", cp2: "" };
          const cancelar = !(
            cargaMarcadaComoNaoAplicavel(resultadoAtual.cp1) &&
            cargaMarcadaComoNaoAplicavel(resultadoAtual.cp2)
          );

          resultados[idadeIndex] = {
            ...resultadoAtual,
            cp1: cancelar ? "-" : "",
            cp2: cancelar ? "-" : ""
          };

          return { ...item, resultados };
        })
      );
      setTemAlteracao(true);
    }

    function formatarParaExibir(valor) {
      if (valor === null || valor === undefined) return "";
      return String(valor).replace(".", ",");
    }

    function getMaiorMpaPorIdade(ensaio, idadeIndex) {
  const cp1 = parseDecimal(ensaio.resultados?.[idadeIndex]?.cp1);
  const cp2 = parseDecimal(ensaio.resultados?.[idadeIndex]?.cp2);

  const mpa1 = calcularResistencia(cp1);
  const mpa2 = calcularResistencia(cp2);

  const n1 = parseFloat((mpa1 || "").replace(",", "."));
  const n2 = parseFloat((mpa2 || "").replace(",", "."));

  return Math.max(n1 || 0, n2 || 0);
}


          function calcularResistencia(cargaTon) {
              if (String(cargaTon ?? "").trim() === "-") return "-";
              if (!cargaTon) return "";

              const cargaNumerica = parseDecimal(cargaTon);
              if (!cargaNumerica) return "";

              const area = Number(form.areaCp) || 7854;

              const resultado = (cargaNumerica * 9806) / area;

              return resultado.toFixed(1).replace(".", ","); // 🔥 vírgula
            }

            function verificarResistenciaElevada(cargaTon) {
              const resistenciaTexto = calcularResistencia(cargaTon);
              const resistencia = Number(
                String(resistenciaTexto || "").replace(",", ".")
              );

              if (!Number.isFinite(resistencia) || resistencia <= 150) return;

              setMensagemAvisoPrensa(
                `A resistência calculada foi de ${resistenciaTexto} MPa. Verifique se o resultado está correto.`
              );
              setOpenAvisoPrensa(true);
            }

            



            
      const headerCellStyle = {
        fontWeight: 600,
        fontSize: 13,
        padding: "4px 8px",
        lineHeight: 1.2,
        whiteSpace: "nowrap"
      };

const subHeaderStyle = {
  fontWeight: 600,
  fontSize: 12,
  padding: "2px 6px",
  lineHeight: 1.1
};

const inputEditavelStyle = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#e8f5e9",
    borderRadius: 1,
    height: 30
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  },
  "& input": {
    textAlign: "center",
    fontWeight: 500,
    padding: "4px 6px",
    fontSize: 13
  }
};


const LinhaCaminhao = React.memo(function LinhaCaminhao({
  ensaio,
  rowIndex,
  form,
  atualizarCampoLocal,
  handleEnter,
  handleEnterCP,
  setEnsaios,
  setTemAlteracao,
  calcularResistencia,
  mpaCalculado,
  setMpaCalculado,
  inputEditavelStyle,
  alterarStatusCaminhao,
  formatarParaExibir
}) {

  return (
    <TableRow
      sx={{
        height: 42,
        "& td": { paddingTop: "4px", paddingBottom: "4px" },
        backgroundColor:
          ensaio.status === "cancelado" ? "#fdecea" : "inherit",
        opacity: ensaio.status === "cancelado" ? 0.6 : 1
      }}
    >

      <TableCell>{ensaio.cod_caminhao}</TableCell>

      {/* TODO O CONTEÚDO INTERNO DA SUA LINHA VAI AQUI */}

    </TableRow>
  );
});

  if (modoRelatorioCompleto && dadosRelatorioCompleto) {
    return (
      <RelatorioTecnicoConsolidado
  moldagens={dadosRelatorioCompleto.moldagens}
  certificados={dadosRelatorioCompleto.certificados}
  cliente={dadosRelatorioCompleto.cliente}
  obra={dadosRelatorioCompleto.obra}
  numeroRelatorioInicial={dadosRelatorioCompleto.numeroRelatorioInicial}
  tipoGeracaoRelatorio={dadosRelatorioCompleto.tipoGeracaoRelatorio}
  numeroRevisaoRelatorio={dadosRelatorioCompleto.numeroRevisaoRelatorio}
  pdfRevisaoAnterior={dadosRelatorioCompleto.pdfRevisaoAnterior}
  semAlteracaoDesdeUltimoSalvamento={dadosRelatorioCompleto.semAlteracaoDesdeUltimoSalvamento}
  listaMoldagens={dadosRelatorioCompleto.moldagens}
  nomeEmpresaSaaS={nomeEmpresaSaaS}
  onVoltar={async () => {
    await carregarObrasAgenda();
    setModoRelatorioCompleto(false);
    setDadosRelatorioCompleto(null);
  }}
/>
    );
  }

  if (modoPrint && (moldagemSelecionada || moldagensFiltradas.length > 0)) {
  return (
   <>
  {(moldagensFiltradas.length > 0
    ? moldagensFiltradas
    : [moldagemSelecionada]
  ).map((moldagem) => (
    <RelatorioRupturaPrint
      key={moldagem.id}
      form={{
        ...form,
        ...moldagem
      }}
      ensaios={moldagem.caminhoes || ensaios}
      calcularResistencia={calcularResistencia}
      obraId={moldagem.obraId}
      listaMoldagens={listaMoldagensNumeracao}
      moldagemId={moldagem.id}
      nomeEmpresaSaaS={nomeEmpresaSaaS}
      autoPrint={false}
      onVoltar={() => {
        setModoPrint(false);
        if (moldagensFiltradas.length > 0) {
          setMoldagensFiltradas([]);
          setMoldagemSelecionada(null);
        } else if (visualizacaoVeioDaLista) {
          setMoldagemSelecionada(null);
        }
        setVisualizacaoVeioDaLista(false);
      }}
    />
  ))}
</>
  );
}

function calcularCodigoPagina(lista, moldagemAtual, rowIndex) {
  if (!lista || !moldagemAtual || obraDados === null) return "-";

  // 🔥 GARANTIA
  if (!lista.some(m => m.id === moldagemAtual.id)) return "-";

  const mesmaObra = lista.filter(
    m => m.obraId === moldagemAtual.obraId
  );

  const ordenada = [...mesmaObra].sort((a, b) =>
    ordenarMoldagensPorNumeracao(a, b)
  );

  let somaPaginas = Number(obraDados?.codigoInicial ?? 0);

  for (const m of ordenada) {
    const qtd = parseInt(m.qtdCaminhoes) || 0;
    const linhasDaPagina =
      m.incluirObservacaoRelatorio === true &&
      String(m.observacaoRelatorio || "").trim() !== ""
        ? 13
        : 14;
    const paginas = Math.ceil(qtd / linhasDaPagina);

    if (m.id === moldagemAtual.id) {
      return somaPaginas + Math.floor(rowIndex / linhasDaPagina) + 1;
    }

    somaPaginas += paginas;
  }

  return "-";
}

function calcularCodigoCaminhaoGlobal(
  lista,
  obraId,
  moldagemId,
  indexCaminhao,
  codigoInicialCaminhao = 0
) {
  if (!lista || !obraId || !moldagemId) return "-";

  const mesmaObra = lista
    .filter(m => m.obraId === obraId)
    .sort((a, b) =>
      ordenarMoldagensPorNumeracao(a, b)
    );

  let soma = Number(codigoInicialCaminhao || 0);

  for (const m of mesmaObra) {
    const qtd = Number(m.qtdCaminhoes || 0);

    if (m.id === moldagemId) {
      return soma + indexCaminhao + 1;
    }

    soma += qtd;
  }

  return "-";
}

  return (
  <Box>
    {tipoUsuario === "cliente" ? <NavbarCliente /> : <Navbar />}

    {moldagemSelecionada && (
      <CabecalhoDetalhes
        titulo="Agenda de Moldagem e Ruptura"
        subtitulo="RQ 2.2.11   Rev.00 - 20/08/2025"
        sx={{ mt: 3.25, top: 86 }}
      >
        <Tooltip title="Visualizar relatório">
          <span>
            <IconButton
              color="primary"
              onClick={() => {
                setVisualizacaoVeioDaLista(false);
                setModoPrint(true);
              }}
              disabled={salvando || temAlteracao}
            >
              <VisibilityIcon />
            </IconButton>
          </span>
        </Tooltip>
        {tipoUsuario !== "cliente" && (
          <Tooltip title="Imprimir relatório">
            <span>
              <IconButton color="primary" onClick={handlePrint} disabled={salvando || temAlteracao}>
                <PrintIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        <Button
          variant="outlined"
          onClick={voltarTelaAnterior}
          disabled={salvando || temAlteracao}
          startIcon={<ArrowBackIcon />}
        >
          Voltar
        </Button>
        {temAlteracao && !somenteLeitura && (
          <>
            <Button
              variant="contained"
              color="success"
              onClick={salvarAlteracoes}
              disabled={salvando}
            >
              {salvando ? "Salvando..." : "Salvar Alterações"}
            </Button>
            <Button data-confirmacao-cancelamento="propria"
              variant="outlined"
              onClick={solicitarCancelarAlteracoes}
              disabled={salvando}
            >
              Cancelar alterações
            </Button>
          </>
        )}
      </CabecalhoDetalhes>
    )}

    {obraSelecionada && !moldagemSelecionada && (
      <CabecalhoDetalhes
        className="cabecalho-exportar-lista"
        titulo="Agenda de Moldagem e Ruptura"
        subtitulo={`RQ 2.2.11   Rev.00 - 20/08/2025 | Obra: ${obraSelecionada}`}
        sx={{ mt: 3.25, top: 86 }}
      >
        <Button
          variant="outlined"
          onClick={voltarTelaAnterior}
          disabled={salvando}
          startIcon={<ArrowBackIcon />}
        >
          Voltar
        </Button>
        {!somenteLeitura && (
          <Button
            variant="contained"
            onClick={novoEnsaioDentroObra}
            disabled={salvando}
          >
            + Cadastrar Moldagem
          </Button>
        )}
        {tipoUsuario !== "cliente" && (
          <>
            <Button
              variant="outlined"
              onClick={() => {
                if (!mostrarFiltroPeriodo) {
                  setMostrarFiltroPeriodo(true);
                  return;
                }
                gerarRelatorioPorPeriodo();
              }}
            >
              {mostrarFiltroPeriodo ? "Filtrar" : "Filtrar por período"}
            </Button>
            <FormControlLabel
              sx={{ m: 0, whiteSpace: "nowrap" }}
              control={
                <Checkbox
                  checked={gerarRelatorioCompleto}
                  onChange={(e) => setGerarRelatorioCompleto(e.target.checked)}
                />
              }
              label="Gerar relatório"
            />
            {gerarRelatorioCompleto && (
              <Button
                variant="contained"
                color="success"
                onClick={() => abrirGeracaoRelatorio()}
                disabled={carregandoRelatorioCompleto}
              >
                {carregandoRelatorioCompleto ? "Gerando..." : "Gerar relatório"}
              </Button>
            )}
          </>
        )}
      </CabecalhoDetalhes>
    )}

    {!obraSelecionada && !moldagemSelecionada && (
      <CabecalhoDetalhes
        className="cabecalho-exportar-lista"
        titulo="Agenda de Moldagem e Ruptura"
        subtitulo="RQ 2.2.11   Rev.00 - 20/08/2025"
        sx={{ mt: 3.25, top: 86 }}
      >
        <Button
          variant="outlined"
          onClick={voltarTelaAnterior}
          disabled={salvando}
          startIcon={<ArrowBackIcon />}
        >
          Voltar
        </Button>
      </CabecalhoDetalhes>
    )}

    <Box p={3}>

    <Stack
  direction="row"
  spacing={2}
  sx={{
    mb: obraSelecionada && !moldagemSelecionada ? 3 : 0,
    alignItems: "center",
    width: "100%",              // 🔥 ESSENCIAL
    justifyContent: "space-between" // 🔥 GARANTE EXTREMOS
  }}
>

  {/* ESQUERDA */}
  <Box sx={{ display: "none", gap: 2, alignItems: "center", flexWrap: "wrap" }}>

    {moldagemSelecionada && (
      <>
        <Tooltip title="Visualizar relatório">
          <span>
            <IconButton
              color="primary"
              onClick={() => {
                setVisualizacaoVeioDaLista(false);
                setModoPrint(true);
              }}
              disabled={salvando || temAlteracao}
            >
              <VisibilityIcon />
            </IconButton>
          </span>
        </Tooltip>
        {tipoUsuario !== "cliente" && (
          <Tooltip title="Imprimir relatório">
            <span>
              <IconButton color="primary" onClick={handlePrint} disabled={salvando || temAlteracao}>
                <PrintIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </>
    )}

    <Button
      variant={moldagemSelecionada ? "outlined" : "contained"}
      color={moldagemSelecionada ? "primary" : "secondary"}
      onClick={voltarTelaAnterior}
      disabled={salvando || temAlteracao}
      startIcon={moldagemSelecionada ? <ArrowBackIcon /> : undefined}
      sx={
        moldagemSelecionada
          ? { fontSize: 0, "&::after": { content: '"Voltar"', fontSize: "0.875rem" } }
          : undefined
      }
    >
      ← Voltar
    </Button>

{!somenteLeitura && !moldagemSelecionada && (
  <Button
    variant="contained"
    onClick={obraSelecionada ? novoEnsaioDentroObra : novoEnsaio}
    disabled={salvando}
  >
    + Cadastrar Moldagem
  </Button>
)}

    {temAlteracao && !somenteLeitura && (
      <>
      <Button
        variant="contained"
        color="success"
        onClick={salvarAlteracoes}
        disabled={salvando}
      >
        {salvando ? "Salvando..." : "Salvar Alterações"}
      </Button>
      <Button data-confirmacao-cancelamento="propria"
        variant="outlined"
        onClick={solicitarCancelarAlteracoes}
        disabled={salvando}
      >
        Cancelar alterações
      </Button>
      </>
    )}

  </Box>

  {/* DIREITA */}
  {obraSelecionada && !moldagemSelecionada && (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexWrap: "nowrap",
        width: "100%",
        overflowX: "auto",
        pt: 1,
        pb: 0.5,
      }}
    >
      <TextField
        label="Pesquisar Moldagem (Data Moldagem ou Data Ruptura)"
        value={pesquisaMoldagem}
        onChange={(e) => {
          setPesquisaMoldagem(e.target.value);
          setPaginaMoldagens(0);
          setLastDocsMoldagens([]);
          setPaginasMoldagens(1);
        }}
        sx={{ flex: "1 1 360px", minWidth: 320 }}
      />

      {tipoUsuario !== "cliente" && mostrarFiltroPeriodo && (
        <>

      <TextField
        type="date"
        label="Data Inicial"
        InputLabelProps={{ shrink: true }}
        value={dataInicio}
        onChange={(e) => setDataInicio(e.target.value)}
        sx={{ flex: "0 0 155px" }}
      />

      <TextField
        type="date"
        label="Data Final"
        InputLabelProps={{ shrink: true }}
        value={dataFim}
        onChange={(e) => setDataFim(e.target.value)}
        sx={{ flex: "0 0 155px" }}
      />

        </>
      )}

    </Box>
  )}

  <Dialog
    open={openTipoRelatorio}
    onClose={() => {
      if (!carregandoRelatorioCompleto) setOpenTipoRelatorio(false);
    }}
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle>Gerar relatório</DialogTitle>
    <DialogContent>
      <RadioGroup
        value={tipoGeracaoRelatorio}
        onChange={(event) => setTipoGeracaoRelatorio(event.target.value)}
        sx={{ mt: 1 }}
      >
        <FormControlLabel
          value="novo"
          control={<Radio />}
          label="Novo relatório"
        />
        <FormControlLabel
          value="revisao"
          control={<Radio />}
          label="Revisão do último relatório"
        />
      </RadioGroup>

     {tipoGeracaoRelatorio === "revisao" && (
  <>
    <TextField
      autoFocus
      fullWidth
      margin="normal"
      label="Número da revisão"
      value={numeroRevisaoRelatorio}
      onChange={(event) =>
        setNumeroRevisaoRelatorio(event.target.value.replace(/\D/g, ""))
      }
      inputProps={{ inputMode: "numeric", maxLength: 5 }}
    />

   

    {pdfRevisaoAnterior && (
      <Typography fontSize={13} sx={{ mt: 1 }}>
        PDF selecionado: {pdfRevisaoAnterior.name}
      </Typography>
    )}
  </>
)}

{exigirPdfAntigo && carregandoPdfAnterior && (
  <Typography fontSize={13} sx={{ mt: 1 }}>
    Procurando relatório anterior salvo...
  </Typography>
)}


{exigirPdfAntigo && !carregandoPdfAnterior && (
  <>
    <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
      <Tooltip title="Configurar códigos do PDF">
        <IconButton
          color={mostrarConfiguracaoCortePdf ? "primary" : "default"}
          onClick={() =>
            setMostrarConfiguracaoCortePdf((valorAtual) => !valorAtual)
          }
          aria-label="Configurar ponto de corte do PDF"
          size="small"
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
    </Box>

    {mostrarConfiguracaoCortePdf && (
      <>
        <Typography fontSize={13} sx={{ mt: 1 }}>
          {pdfAnteriorAutomatico
            ? `PDF-base atual: ${pdfAnteriorAutomatico.nomeArquivo}`
            : "Nenhum PDF-base foi cadastrado para esta obra."}
        </Typography>

        <Button
          variant="outlined"
          component="label"
          fullWidth
          sx={{ mt: 1 }}
        >
          {pdfAnteriorAutomatico ? "Substituir PDF-base" : "Selecionar PDF-base"}

          <input
            hidden
            type="file"
            accept="application/pdf"
            onChange={(event) => {
              const arquivo = event.target.files?.[0] || null;
              setUploadRelatorioAntigo(arquivo);
            }}
          />
        </Button>

        {uploadRelatorioAntigo && (
          <Typography fontSize={13} sx={{ mt: 1 }}>
            PDF selecionado: {uploadRelatorioAntigo.name}
          </Typography>
        )}

        <TextField
          fullWidth
          margin="normal"
          type="number"
          label="Último código de página existente no PDF"
          value={ultimoCodigoPaginaPdf}
          onChange={(event) =>
            setUltimoCodigoPaginaPdf(event.target.value.replace(/\D/g, ""))
          }
          onWheel={impedirAlteracaoNumeroNoScroll}
          inputProps={{ min: 0, inputMode: "numeric" }}
        />

        <TextField
          fullWidth
          margin="dense"
          type="number"
          label="Último código de caminhão existente no PDF"
          value={ultimoCodigoCaminhaoPdf}
          onChange={(event) =>
            setUltimoCodigoCaminhaoPdf(event.target.value.replace(/\D/g, ""))
          }
          onWheel={impedirAlteracaoNumeroNoScroll}
          inputProps={{ min: 0, inputMode: "numeric" }}
        />

        <Typography fontSize={12} color="text.secondary" sx={{ mt: 0.5 }}>
          O próximo relatório incluirá somente as páginas posteriores a esse
          corte e continuará a numeração informada.
        </Typography>

        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 1 }}
          disabled={
            !uploadRelatorioAntigo ||
            !ultimoCodigoPaginaPdf ||
            !ultimoCodigoCaminhaoPdf ||
            salvandoRelatorioAntigo
          }
          onClick={salvarPdfAntigoDaObra}
        >
          {salvandoRelatorioAntigo
            ? "Salvando PDF-base..."
            : pdfAnteriorAutomatico
              ? "Salvar substituição e corte"
              : "Salvar PDF-base e corte"}
        </Button>
      </>
    )}

    {!pdfAnteriorAutomatico && <FormControlLabel
      sx={{ mt: 1 }}
      control={
        <Checkbox
          checked={usarSemPdfAnterior}
          onChange={(event) => setUsarSemPdfAnterior(event.target.checked)}
        />
      }
      label="Continuar sem PDF antigo"
    />}
  </>
)}


    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => setOpenTipoRelatorio(false)}
        disabled={carregandoRelatorioCompleto}
      >
        Cancelar
      </Button>
      <Button
        variant="contained"
        onClick={() => gerarRelatorioTecnicoCompleto()}
        
         disabled={
  carregandoRelatorioCompleto ||
  carregandoPdfAnterior ||
  salvandoRelatorioAntigo ||
  (
    exigirPdfAntigo &&
    !pdfAnteriorAutomatico &&
    !usarSemPdfAnterior
  ) ||
  (
    tipoGeracaoRelatorio === "revisao" &&
    !numeroRevisaoRelatorio
  )
}
      >
        {carregandoRelatorioCompleto ? "Carregando..." : "Continuar"}
      </Button>
    </DialogActions>
  </Dialog>

  {/* IMPRIMIR */}
  {false && moldagemSelecionada && !somenteLeitura && tipoUsuario !== "cliente" && (
    <Button
      variant="contained"
      onClick={handlePrint}
      disabled={salvando || temAlteracao}
    >
      Imprimir
    </Button>
  )}

</Stack>


{obraSelecionada && !moldagemSelecionada && (
  <>
    <Paper>
      {carregandoMoldagens && listaMoldagens.length === 0 && (
        <Box sx={{ py: 2, px: 2 }}>
          <Typography>Carregando moldagens...</Typography>
        </Box>
      )}

      {moldagensDaObraSelecionada
        .filter(item => {
            const texto = pesquisaMoldagem.toLowerCase().trim();

          return (
  formatarDataBR(item.datamoldagem)?.includes(texto) ||
  item.datasRuptura?.some(data =>
    formatarDataBR(data)?.includes(texto)
  ) ||

  // 🔥 BUSCA NOS CAMINHÕES
  item.caminhoes?.some(c =>
    contemTextoPesquisa(String(c.notaFiscalRomaneio || "").toLowerCase(), texto) ||
contemTextoPesquisa(String(c.pecaConcretada || "").toLowerCase(), texto)
  )
);
          })
        .map(item => (
  <Box
    key={item.id}
    sx={{
      p: 2,
      borderBottom: "1px solid #eee",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}
  >
    <Box
  sx={{ cursor: tipoUsuario === "cliente" ? "default" : "pointer" }}
  onClick={async () => {
    if (tipoUsuario === "cliente") return;

    const moldagemAtualizada = await abrirMoldagem(item);
    setMoldagemSelecionada(moldagemAtualizada || item);
  }}
>
      <Typography
        fontWeight={600}
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        <Box component="span">
          Data: {formatarDataBR(item.datamoldagem)}
        </Box>
        {obraDados?.rupturaExternaPadrao === true && item.rupturaExterna !== true && (
          <Typography
            component="span"
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: "#8a6500",
              bgcolor: "#fff3cd",
              border: "1px solid #ffe08a",
              borderRadius: 0.75,
              px: 0.75,
              py: 0.15,
              whiteSpace: "nowrap",
            }}
          >
            Ruptura externa não selecionada
          </Typography>
        )}
        {moldagemTemIdadeSemCargaLancada(item) && (
  <>
    <Tooltip
      title={`Falta romper: ${obterIdadesSemCargaLancada(item).join(", ")}`}
    >
      <Box
        component="span"
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          bgcolor: "#16a34a",
          flexShrink: 0
        }}
      />
    </Tooltip>

    <Typography
      component="span"
      sx={{
        fontSize: 13,
        fontWeight: 600,
        color: "#16a34a",
        whiteSpace: "nowrap"
      }}
    >
      Falta romper: {obterIdadesSemCargaLancada(item).join(", ")}
    </Typography>
  </>
)}

      </Typography>

      <Typography variant="body2">
        Moldador: {item.moldador} | Qtd Caminhões: {item.qtdCaminhoes}
      </Typography>
    </Box>

    <Stack direction="row" spacing={1}>
      <Tooltip title="Visualizar">
        <IconButton
          size="small"
          onClick={async (e) => {
            e.stopPropagation();
            await visualizarMoldagem(item, false);
          }}
        >
          <VisibilityIcon sx={{ color: "primary.main" }} />
        </IconButton>
      </Tooltip>

  {!somenteLeitura && (
  <Tooltip title="Editar">
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        abrirEdicaoDireta(item);
      }}
    >
      <EditIcon sx={{ color: "#0288d1" }} />
    </IconButton>
  </Tooltip>
  )}

  <Button
    variant="contained"
    size="small"
    sx={{ minWidth: 0, display: somenteLeitura ? "none" : "inline-flex" }}
    onClick={(e) => {
      e.stopPropagation();
      abrirHistorico(item.id);
    }}
  >
    <HistoryIcon fontSize="small" />
  </Button>
</Stack>
<Dialog
  open={openHistorico}
  onClose={() => setOpenHistorico(false)}
  fullWidth
  maxWidth="md"
>
  <DialogTitle>Histórico de alterações</DialogTitle>

  <DialogContent dividers>
    {historico.length === 0 && (
      <Typography>Nenhuma alteração registrada.</Typography>
    )}

    {historico.map(item => (
      <Box
        key={item.id}
        sx={{
          mb: 2,
          p: 2,
          border: "1px solid #eee",
          borderRadius: 1
        }}
      >
        <Typography fontWeight={600}>
          {formatarTipoHistoricoAgenda(item.tipo, item.descricao)}
        </Typography>

        <Typography fontSize={13}>
          {item.descricao}
        </Typography>

        <Typography fontSize={12} color="text.secondary">
          Data e hora: {formatarDataHistoricoAgenda(item.data)}
        </Typography>

        <Typography fontSize={12} color="text.secondary">
          Responsável: {item.usuarioEmail || item.usuario || "Usuário não identificado"}
        </Typography>
      </Box>
    ))}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenHistorico(false)}>
      Fechar
    </Button>
  </DialogActions>
</Dialog>

  </Box>
))}

      {!carregandoMoldagens && moldagensDaObraSelecionada.length === 0 && (
        <Box sx={{ py: 2, px: 2 }}>
          <Typography>Nenhuma moldagem encontrada para esta obra.</Typography>
        </Box>
      )}

      {pesquisaMoldagem.trim() === "" && (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2 }}>
          <PaginationSelector
            itensPerPage={itensPorPaginaMoldagens}
            setItensPerPage={(valor) => {
              setItensPorPaginaMoldagens(valor);
              setPaginaMoldagens(0);
              setLastDocsMoldagens([]);
              setPaginasMoldagens(1);
            }}
          />
          <PaginationComponent
            pages={paginasMoldagens}
            currentPage={paginaMoldagens}
            setCurrentPage={setPaginaMoldagens}
          />
        </Stack>
      )}
    </Paper>
  </>
)}


{!obraSelecionada && !somenteLeitura && (
  <>

    <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label="Pesquisar Obra/Cliente"
        value={pesquisaObra}
        onChange={(e) => setPesquisaObra(e.target.value)}
      />

      <TextField
        select
        label="Filtrar Obras"
        value={filtroRelatorioObra}
        onChange={(e) => {
          const novoFiltro = e.target.value;
          setFiltroRelatorioObra(novoFiltro);
        }}
        sx={{ width: { xs: "100%", md: 240 }, flexShrink: 0 }}
      >
        <MenuItem value="todos">Todas</MenuItem>
        <MenuItem value="pendentes">Relatórios a enviar</MenuItem>
        <MenuItem value="cadastrados">Relatórios cadastrados</MenuItem>
      </TextField>
    </Stack>

    <Paper>
      {carregandoObrasAgenda && (
        <Box sx={{ py: 2, px: 2 }}>
          <Typography>Carregando obras...</Typography>
        </Box>
      )}

      {!carregandoObrasAgenda && obrasFiltradasAgenda.length > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            px: 2,
            py: 1,
            bgcolor: "#f8fafc",
            borderBottom: "1px solid #d7dce3"
          }}
        >
          <Box sx={{ minWidth: 34 }} />
          <Typography fontWeight={700} color="#003b7a">
            Cliente / Obra
          </Typography>
        </Box>
      )}

      {!carregandoObrasAgenda && obrasFiltradasAgenda.map((obra, index) => {
        const nomeCliente =
          obra.clienteNome ||
          obra.cliente ||
          clientes.find((cliente) => cliente.id === obra.clienteId)?.nome ||
          "Cliente não informado";

        return (
          <Box
  key={obra.id}
  sx={{
    py: 1,
    px: 2,
    borderBottom: "1px solid #eee",
    cursor: "pointer",
    display: "flex",
    gap: 1.5,
    alignItems: "center"
  }}
  onClick={() => {
    setObraSelecionada(obra.nome || "");
    setObraSelecionadaId(obra.id);
    setObraDados(obra);
    setPesquisaMoldagem("");
    setListaMoldagens([]);
    setListaMoldagensNumeracao([]);
    setPaginaMoldagens(0);
    setLastDocsMoldagens([]);
    setPaginasMoldagens(1);
  }}
>
  <Typography fontWeight={700} sx={{ minWidth: 34, color: "#00084d" }}>
    {index + 1}.
  </Typography>
  <Box sx={{ minWidth: 0, flex: 1 }}>
    <Typography fontWeight={600} noWrap>
      {nomeCliente}
    </Typography>
    <Typography
      noWrap
      color="text.secondary"
      sx={{ mt: 0.25 }}
    >
      Obra: {obra.nome}
    </Typography>
  </Box>
  <Typography
    fontSize={13}
    color="text.secondary"
    sx={{ ml: "auto", flexShrink: 0, whiteSpace: "nowrap" }}
  >
    Última alteração: {formatarTimestampBR(obra.ultimaalteracaoagendaruptura)}
  </Typography>
  <Button
    variant="contained"
    color="success"
    size="small"
    startIcon={<PrintIcon />}
    sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
    onClick={(event) => {
      event.stopPropagation();
      abrirGeracaoRelatorio(obra);
    }}
  >
    Gerar relatório
  </Button>
</Box>

        );
      })}

      {!carregandoObrasAgenda && obrasFiltradasAgenda.length === 0 && (
        <Box sx={{ py: 2, px: 2 }}>
          <Typography>Nenhuma obra encontrada.</Typography>
        </Box>
      )}
    </Paper>

    {!pesquisaObra.trim() && (
      <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2}>
        <PaginationSelector
          itensPerPage={itensPorPaginaObrasAgenda}
          setItensPerPage={setItensPorPaginaObrasAgenda}
        />
        <PaginationComponent
          pages={paginasObrasAgenda}
          currentPage={paginaObrasAgenda}
          setCurrentPage={setPaginaObrasAgenda}
        />
      </Stack>
    )}
  </>
)}

      {/* CABEÇALHO */}
    {moldagemSelecionada && (

  <>
    {exibirCamposCodigoInicial && mostrarInputCodigo && (
      <Paper sx={{ p: 2, mb: 2, background: "#fff3cd" }}>
        <Typography fontWeight={600} mb={1}>
          Definir código inicial da obra
        </Typography>
<TextField
  label="Código inicial caminhão"
  type="number"
  value={codigoInicialCaminhaoInput}
  onChange={(e) => setCodigoInicialCaminhaoInput(e.target.value)}
  onWheel={impedirAlteracaoNumeroNoScroll}
  sx={{ mr: 2 }}
/>
        <TextField
          label="Código inicial"
          type="number"
          value={codigoInicialInput}
          onChange={(e) => setCodigoInicialInput(e.target.value)}
          onWheel={impedirAlteracaoNumeroNoScroll}
          sx={{ mr: 2 }}
        />

        <Button
          variant="contained"
          onClick={async () => {
            if (!codigoInicialInput && !codigoInicialCaminhaoInput) return;

            const obraId = form.obraId;

if (!obraId) {
  alert("Obra não identificada");
  return;
}

await updateDoc(doc(db, "obras", obraId), {
  codigoInicial: Number(codigoInicialInput),
  codigoInicialCaminhao: Number(codigoInicialCaminhaoInput || 0)
});

            setMostrarInputCodigo(false);
          }}


      
        >
          Salvar
        </Button>
      </Paper>
    )}

    <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>


        <Box
  sx={{
    width: "95%",
    maxWidth: "1600px"
  }}
>
{/* BLOCO DO TÍTULO */}
<Box
  sx={{
    background: "#fff",
    borderRadius: 2,
    boxShadow: 2,
    px: 3,
    py: 1, // 🔥 menor altura
    mb: 2,
    textAlign: "center"
  }}
>
  <Typography sx={{ fontWeight: 700, fontSize: 15, lineHeight: 1.3 }}>
    SISTEMA DE GESTÃO DA QUALIDADE
  </Typography>

  <Typography sx={{ fontWeight: 600, fontSize: 14, lineHeight: 1.3 }}>
    CONTROLE DE CONCRETAGEM
  </Typography>

  <Typography sx={{ fontWeight: 500, fontSize: 13, lineHeight: 1.3 }}>
    (MOLDAGEM E ABATIMENTO "SLUMP TEST")
  </Typography>
</Box>

          {/* LINHA 1 */}
          <Grid
  container
  mb={0.5}
  alignItems="stretch"
  justifyContent="space-between"
>

  {/* ESQUERDA */}
  <Grid sx={{ flex: 1, mr: 1 }}>
    <Box sx={campoBox}>
      <Typography sx={labelStyle}>CLIENTE:</Typography>
      <Typography sx={valorStyle}>{form.cliente}</Typography>
      
    </Box>
  </Grid>

  {/* DIREITA AGRUPADA */}
  <Grid>
    <Stack direction="row" spacing={2}>
      <Box sx={campoBox}>
        <Typography sx={labelStyle}>DATA:</Typography>
        <Typography sx={valorStyle}>
  {formatarDataBR(form.datamoldagem)}
</Typography>

      </Box>

      <Box sx={campoBox}>
        <Typography sx={labelStyle}>INÍCIO:</Typography>
        <Typography sx={valorStyle}>{form.inicioConcretagem}</Typography>
      </Box>

      <Box sx={campoBox}>
        <Typography sx={labelStyle}>TÉRMINO:</Typography>
        <Typography sx={valorStyle}>{form.terminoConcretagem}</Typography>
      </Box>
    </Stack>
  </Grid>

</Grid>


          {/* LINHA 2 */}
          <Grid
  container
  mb={0.5}
  justifyContent="space-between"
>

  {/* ESQUERDA */}
  <Grid sx={{ flex: 1, mr: 2 }}>
    <Box sx={campoBox}>
      <Typography sx={labelStyle}>OBRA:</Typography>
      <Typography sx={valorStyle}>{form.obra}</Typography>
    </Box>
  </Grid>

  {/* DIREITA */}
  <Grid>
    <Box sx={campoBox}>
      <Typography sx={labelStyle}>MOLDADOR:</Typography>
      <Typography sx={valorStyle}>{form.moldador}</Typography>
    </Box>
  </Grid>

</Grid>



          {/* LINHA 3 */}
          <Grid
  container
  justifyContent="space-between"
>

  <Grid sx={{ flex: 1, mr: 2 }}>
    <Box sx={campoBox}>
      <Typography sx={labelStyle}>CONCRETEIRA:</Typography>
      <Typography sx={valorStyle}>{form.concreteira}</Typography>
    </Box>

    {!somenteLeitura && tipoUsuario !== "cliente" && (
      <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
        {form.rupturaExterna === true && (
          <TextField
            select
            size="small"
            label="Filtrar prensa por"
            value={filtroPrensaExterna}
            onChange={(e) => {
              setFiltroPrensaExterna(e.target.value);
              setForm((anterior) => ({
                ...anterior,
                prensaRuptura: null
              }));
              setTemAlteracao(true);
            }}
            sx={{ minWidth: 155 }}
          >
            <MenuItem value="todos">Todos</MenuItem>
            <MenuItem value="obra">Obra</MenuItem>
            <MenuItem value="cliente">Cliente</MenuItem>
            <MenuItem value="calibracao-externa">Calibração externa</MenuItem>
          </TextField>
        )}

        <TextField
          select
          fullWidth
          size="small"
          label="Prensa utilizada para ruptura"
          value={form.prensaRuptura?.id || ""}
          onChange={async (e) => {
            const prensaSelecionada = filtrarCalibracoesPrensa(
              calibracoesPrensa,
              calibracoesExternasPrensa,
              form.rupturaExterna,
              filtroPrensaExterna,
              form.obra,
              form.cliente
            ).find((prensa) => prensa.id === e.target.value);

            if (
              prensaSelecionada &&
              !(await confirmarPrensaCalibradaParaRupturas(
                prensaSelecionada,
                calcularDatasRuptura(form.datamoldagem, form.idades)
              ))
            ) {
              return;
            }

            setForm({
              ...form,
              prensaRuptura: prensaSelecionada
                ? { id: prensaSelecionada.id, ...prensaSelecionada }
                : null
            });
            setTemAlteracao(true);
          }}
        >
          <MenuItem value="">Selecione a prensa utilizada</MenuItem>
          {[
            ...filtrarCalibracoesPrensa(
              calibracoesPrensa,
              calibracoesExternasPrensa,
              form.rupturaExterna,
              filtroPrensaExterna,
              form.obra,
              form.cliente
            ),
            ...(form.prensaRuptura?.id &&
            !filtrarCalibracoesPrensa(
              calibracoesPrensa,
              calibracoesExternasPrensa,
              form.rupturaExterna,
              filtroPrensaExterna,
              form.obra,
              form.cliente
            ).some((prensa) => prensa.id === form.prensaRuptura.id)
              ? [form.prensaRuptura]
              : [])
          ].map((prensa) => (
            <MenuItem key={prensa.id} value={prensa.id}>
              {formatarPrensaRuptura(prensa)}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    )}
  </Grid>

  <Grid>
    <Stack direction="row" spacing={2}>
      <Box sx={campoBox}>
        <Typography sx={labelStyle}>FCK:</Typography>
        <Typography sx={valorStyle}>{form.fckProjeto}</Typography>
      </Box>

      <Box sx={campoBox}>
        <Typography sx={labelStyle}>
          {ehSlumpFlow(form.slumpProjeto) ? "SLUMP FLOW:" : "SLUMP:"}
        </Typography>
        <Typography sx={valorStyle}>
          {form.slumpProjeto} ± {form.toleranciaSlumpProjeto}
        </Typography>
      </Box>

      <Box sx={campoBox}>
        <Typography sx={labelStyle}>TIPO DE DESCARGA:</Typography>
        <Typography sx={valorStyle}>
          {formatarTipoLancamento(form.tipoLancamento)}
        </Typography>
      </Box>
      
    </Stack>
  </Grid>

</Grid>

<Paper sx={{ mt: 3 }}>
  <Box
    sx={{
      width: "100%",
      overflowX: "auto",   // 🔥 habilita scroll horizontal
      overflowY: "hidden"
    }}
  >
    <Table
      sx={{
        minWidth: 1200 // 🔥 força largura mínima
      }}
    >
    <TableHead>
        {/* LINHA 1 – TÍTULOS PRINCIPAIS */}
        <TableRow sx={{ height: 28 }}>
          <TableCell
            rowSpan={2}
            align="center"
            sx={{ ...headerCellStyle, width: 42 }}
          >
            Nº
          </TableCell>

          <TableCell rowSpan={2} sx={{ ...headerCellStyle, width: 50 }}>
              CÓD.
            </TableCell>

            <TableCell
                rowSpan={2}
                align="center"
                sx={{ ...headerCellStyle, width: 85 }}
              >
                NOTA
              </TableCell>

            <TableCell rowSpan={2} sx={{ ...headerCellStyle, width: 70 }}>
              <Box textAlign="center">
                QTD
                <Typography variant="caption" display="block" sx={{ lineHeight: 1 }}>
                  m³
                </Typography>
              </Box>
            </TableCell>

            <TableCell rowSpan={2} sx={{ ...headerCellStyle, width: 90 }}>
              <Box textAlign="center">
                {ehSlumpFlow(form.slumpProjeto) ? "SLUMP FLOW" : "SLUMP"}
                <Typography variant="caption" display="block" sx={{ lineHeight: 1 }}>
                  mm
                </Typography>
              </Box>
            </TableCell>

           

          {form.idades?.map((idade, index) => {
                const data = form.datasRuptura?.[index];

                return (
                  <TableCell
                    key={index}
                    colSpan={2}
                    align="center"
                    sx={headerCellStyle}
                  >
                    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
                      <span>
  {isNaN(Number((idade.dias || "").trim()))
    ? idade.dias
    : `${idade.dias} dias`}
</span>
                      <span style={{ fontSize: 11, fontWeight: 500 }}>
                        {data ? formatarDataBR(data) : "-"}
                      </span>
                    </div>
                  </TableCell>
                );
              })}

           <TableCell rowSpan={2} sx={{ ...headerCellStyle, width: 280 }}>
              PEÇA
            </TableCell>

          <TableCell rowSpan={2} sx={headerCellStyle}>
            OBSERVAÇÕES
          </TableCell>

          <TableCell rowSpan={2} sx={headerCellStyle}>
            AÇÃO
          </TableCell>
        </TableRow>

        {/* LINHA 2 – SUBTÍTULOS */}
        <TableRow sx={{ height: 25 }}>
          {form.idades?.map((_, index) => (
            <React.Fragment key={index}>
              <TableCell align="center" sx={subHeaderStyle}>
                (ton)
              </TableCell>
              <TableCell align="center" sx={subHeaderStyle}>
                (MPa)
              </TableCell>
            </React.Fragment>
          ))}
        </TableRow>
      </TableHead>



    <TableBody>
      {ensaios.map((ensaio, rowIndex) => (
  <LinhaAgendaMemoizada
    key={ensaio.id || rowIndex}
    ensaio={ensaio}
    rowIndex={rowIndex}
    idades={form.idades}
    areaCp={form.areaCp}
    somenteLeitura={somenteLeitura}
    moldagemId={moldagemSelecionada?.id}
    obraId={moldagemSelecionada?.obraId}
    codigoInicialCaminhao={obraDados?.codigoInicialCaminhao}
    listaMoldagensNumeracao={listaMoldagensNumeracao}
  >
  <TableRow
    sx={{
      height: 42,
      "& td": { paddingTop: "4px", paddingBottom: "4px" },
      backgroundColor:
        ensaio.status === "cancelado" ? "#fdecea" : "inherit",
      opacity: ensaio.status === "cancelado" ? 0.6 : 1
    }}
  >

         <TableCell align="center">
           {rowIndex + 1}
         </TableCell>

         <TableCell>
  {calcularCodigoCaminhaoGlobal(
    listaMoldagensNumeracao,
    moldagemSelecionada?.obraId,
    moldagemSelecionada?.id,
    rowIndex,
    obraDados?.codigoInicialCaminhao
  )}
</TableCell>

          <TableCell
                sx={{
                  width: 85,
                  textAlign: "center",
                  padding: "4px 6px"
                }}
              >
                <Box display="flex" justifyContent="center">
                  <TextField
                      autoComplete="new-off"
                      variant="outlined"
                      sx={inputEditavelStyle}
                      size="small"
                    disabled={ensaio.status === "cancelado"}
                    value={ensaio.notaFiscalRomaneio || ""}
                    onKeyDown={(e) => handleEnter(e, "notaFiscalRomaneio")}
                    onChange={(e) =>
                      atualizarCampoLocal(
                        ensaio.id,
                        "notaFiscalRomaneio",
                        e.target.value
                      )
                    }
                    inputProps={{
                      autoComplete: "off",
                      "data-field": "notaFiscalRomaneio",
                      style: {
                        textAlign: "center",
                        width: 70
                      }
                    }}
                
                  />
                </Box>
              </TableCell>
          <TableCell>
            <TextField
            autoComplete="off"
                  variant="outlined"
                  sx={inputEditavelStyle}
                  type="text"
                  inputMode="decimal"
                  size="small"
                  disabled={ensaio.status === "cancelado"}
                  inputProps={{
                    autoComplete: "off",
                    "data-field": "qtd",
                    style: { textAlign: "center" }
                  }}
                  onKeyDown={(e) => handleEnter(e, "qtd")}
                  onBlur={() => formatarQtdLocal(ensaio.id)}
                  value={formatarQtdParaCampo(ensaio.qtd) || ""}
                  onChange={(e) =>
                    atualizarCampoLocal(
                      ensaio.id,
                      "qtd",
                      e.target.value
                    )
                  }
                />


          </TableCell>

          <TableCell>
            <TextField
            autoComplete="off"
                variant="outlined"
                sx={inputEditavelStyle}
                type="number"
                size="small"
                disabled={ensaio.status === "cancelado"}
                onWheel={impedirAlteracaoNumeroNoScroll}
                inputProps={{
                  autoComplete: "off",
                  "data-field": "slumpObtido",
                  style: { textAlign: "center" }
                }}
                onKeyDown={(e) => handleEnter(e, "slumpObtido")}
                value={ensaio.slumpObtido || ""}
                onChange={(e) =>
                  atualizarCampoLocal(
                    ensaio.id,
                    "slumpObtido",
                    e.target.value
                  )
                }
              />


          </TableCell>
          

  

         {form.idades?.map((idade, idadeIndex) => (
            <React.Fragment key={idadeIndex}>
              
              {/* COLUNA TON */}
                  <TableCell
                    sx={{
                      minWidth: 75,
                      width: 75,
                      textAlign: "center",
                      verticalAlign: "top",
                      paddingLeft: 1,
                      paddingRight: 1
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5
                      }}
                    >

                      {/* CP1 TON */}
                      <TextField
                          autoComplete="off"
                          variant="outlined"
                          sx={inputEditavelStyle}
                          size="small"
                          fullWidth
                          disabled={
                            ensaio.status === "cancelado" ||
                            idadeCaminhaoCancelada(ensaio, idadeIndex)
                          }
                          value={formatarCargaParaCampo(
                            ensaio.resultados?.[idadeIndex]?.cp1
                          ) || ""}
                          inputProps={{
                          autoComplete: "off",
                          "data-pos": `${rowIndex}-${idadeIndex}-0`,
                          inputMode: "decimal"
                        }}
                          onKeyDown={(e) =>
                            handleEnterCP(e, rowIndex, idadeIndex, 0)
                          }
                          onBlur={() => {
                            formatarCargaLocal(ensaio.id, idadeIndex, "cp1");
                            verificarResistenciaElevada(
                              ensaio.resultados?.[idadeIndex]?.cp1
                            );
                          }}
                          onChange={async (e) => {
                            const valor = e.target.value;
                            if (!(await confirmarPrensaVencidaAoDigitarCarga(valor, idadeIndex))) return;
                            preencherPrensaVinculadaAoDigitarCarga(valor);

                            setEnsaios(prev => {
                              const novaLista = [...prev];
                              const index = novaLista.findIndex(i => i.id === ensaio.id);
                              if (index === -1) return prev;

                              const item = { ...novaLista[index] };

                              const resultados = item.resultados
                                ? [...item.resultados]
                                : Array(form.idades.length)
                                    .fill(null)
                                    .map(() => ({ cp1: "", cp2: "" }));

                              if (!resultados[idadeIndex])
                                resultados[idadeIndex] = { cp1: "", cp2: "" };

                              resultados[idadeIndex] = {
                                ...resultados[idadeIndex],
                                cp1: valor
                              };

                              item.resultados = resultados;
                              novaLista[index] = item;

                              return novaLista;
                            });

                            setTemAlteracao(true);
                          }}
                        />

                      {/* CP2 TON */}
                  <TextField
              autoComplete="off"
              variant="outlined"
              sx={inputEditavelStyle}
              size="small"
              fullWidth
              disabled={
                ensaio.status === "cancelado" ||
                idadeCaminhaoCancelada(ensaio, idadeIndex)
              }
              value={formatarCargaParaCampo(
                ensaio.resultados?.[idadeIndex]?.cp2
              ) || ""}
              inputProps={{
                        autoComplete: "off",
                        "data-pos": `${rowIndex}-${idadeIndex}-1`,
                        inputMode: "decimal"
                      }}
              onKeyDown={(e) =>
                handleEnterCP(e, rowIndex, idadeIndex, 1)
              }
              onBlur={() => {
                formatarCargaLocal(ensaio.id, idadeIndex, "cp2");
                verificarResistenciaElevada(
                  ensaio.resultados?.[idadeIndex]?.cp2
                );
              }}
              onChange={async (e) => {
                const valor = e.target.value;
                if (!(await confirmarPrensaVencidaAoDigitarCarga(valor, idadeIndex))) return;
                preencherPrensaVinculadaAoDigitarCarga(valor);

                setEnsaios(prev => {
                  const novaLista = [...prev];
                  const index = novaLista.findIndex(i => i.id === ensaio.id);
                  if (index === -1) return prev;

                  const item = { ...novaLista[index] };

                  const resultados = item.resultados
                    ? [...item.resultados]
                    : Array(form.idades.length)
                        .fill(null)
                        .map(() => ({ cp1: "", cp2: "" }));

                  if (!resultados[idadeIndex])
                    resultados[idadeIndex] = { cp1: "", cp2: "" };

                  resultados[idadeIndex] = {
                    ...resultados[idadeIndex],
        cp2: valor
      };

      item.resultados = resultados;
      novaLista[index] = item;

      return novaLista;
    });

    setTemAlteracao(true);
  }}
/>

                      {!somenteLeitura && (
                        <Button
                          size="small"
                          color={idadeCaminhaoCancelada(ensaio, idadeIndex) ? "success" : "error"}
                          disabled={ensaio.status === "cancelado"}
                          onClick={() => alternarCancelamentoIdade(ensaio.id, idadeIndex)}
                          sx={{
                            minWidth: 0,
                            px: 0.5,
                            py: 0,
                            fontSize: "0.6rem",
                            lineHeight: 1.1
                          }}
                        >
                          {idadeCaminhaoCancelada(ensaio, idadeIndex)
                            ? "Ativar idade"
                            : "Cancelar idade"}
                        </Button>
                      )}

                    </Box>
                  </TableCell>
              {/* COLUNA MPa (RUNTIME) */}
<TableCell>
  <Box sx={{ display: "flex", flexDirection: "column" }}>
    {(() => {
  const maiorAtual = getMaiorMpaPorIdade(ensaio, idadeIndex);
  const maiorAnterior =
    idadeIndex > 0
      ? getMaiorMpaPorIdade(ensaio, idadeIndex - 1)
      : null;

  const erro =
    maiorAnterior !== null &&
    maiorAtual > 0 &&
    maiorAtual < maiorAnterior;

  return (
    <>
      <Box sx={{ minHeight: 28, display: "flex", alignItems: "center" }}>
        <Typography fontWeight={600} color={erro ? "error" : "inherit"}>
          {calcularResistencia(
            ensaio.resultados?.[idadeIndex]?.cp1
          )}
        </Typography>
      </Box>

      <Box sx={{ minHeight: 28, display: "flex", alignItems: "center" }}>
        <Typography fontWeight={600} color={erro ? "error" : "inherit"}>
          {calcularResistencia(
            ensaio.resultados?.[idadeIndex]?.cp2
          )}
        </Typography>
      </Box>
    </>
  );
})()}

         

            </Box>
          </TableCell>

            </React.Fragment>
          ))}
                
            <TableCell sx={{ width: 130 }}>
              <TextField
              autoComplete="off"
                variant="outlined"
                sx={inputEditavelStyle}
                size="small"
                fullWidth
                disabled={ensaio.status === "cancelado"}
                inputProps={{
                  autoComplete: "off",
                  "data-field": "pecaConcretada"
                }}
                onKeyDown={(e) => handleEnter(e, "pecaConcretada")}
                value={ensaio.pecaConcretada || ""}
                onChange={(e) =>
                  atualizarCampoLocal(
                    ensaio.id,
                    "pecaConcretada",
                    e.target.value
                  )
                }
              />
            </TableCell>

                  {/* OBSERVAÇÕES */}
            <TableCell>
              <TextField
               autoComplete="off"
                variant="outlined"
                sx={inputEditavelStyle}
                fullWidth
                disabled={ensaio.status === "cancelado"}
                inputProps={{ "data-field": "observacoes" }}
                
                onKeyDown={(e) => handleEnter(e, "observacoes")}
                value={ensaio.observacoes || ""}
                onChange={(e) =>
                  atualizarCampoLocal(
                    ensaio.id,
                    "observacoes",
                    e.target.value
                  )
                }
              />
            </TableCell>

            {/* AÇÃO */}
            <TableCell>
              <Stack spacing={0.5} alignItems="center">
                {!somenteLeitura && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={ensaio.moduloElasticidade === true}
                        disabled={ensaio.status === "cancelado"}
                        onChange={(e) =>
                          atualizarCampoLocal(
                            ensaio.id,
                            "moduloElasticidade",
                            e.target.checked
                          )
                        }
                      />
                    }
                    label="ME"
                    sx={{ m: 0 }}
                  />
                )}
                <Button
                  size="small"
                  variant="contained"
                  color={ensaio.status === "cancelado" ? "success" : "error"}
                  onClick={() => alterarStatusCaminhao(ensaio.id)}
                >
                  {ensaio.status === "cancelado" ? "Ativar" : "Cancelar"}
                </Button>
              </Stack>
            </TableCell>
            

        </TableRow>
  </LinhaAgendaMemoizada>
      ))}
    </TableBody>
  </Table>
  </Box>
</Paper>

{!somenteLeitura && (
  <Paper sx={{ mt: 2, p: 2 }}>
    <FormControlLabel
      control={
        <Checkbox
          checked={form.incluirObservacaoRelatorio === true}
          onChange={(e) => {
            const marcado = e.target.checked;
            setForm((anterior) => ({
              ...anterior,
              incluirObservacaoRelatorio: marcado,
              observacaoRelatorio: marcado
                ? anterior.observacaoRelatorio || ""
                : ""
            }));
            setTemAlteracao(true);
          }}
        />
      }
      label="Cadastrar observação no relatório"
    />

    {form.incluirObservacaoRelatorio === true && (
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="Observação do relatório"
        value={form.observacaoRelatorio || ""}
        onChange={(e) => {
          setForm((anterior) => ({
            ...anterior,
            observacaoRelatorio: e.target.value
          }));
          setTemAlteracao(true);
        }}
        sx={{ mt: 1 }}
      />
    )}
  </Paper>
)}

{!temAlteracao && (
<div style={{ display: "none" }}>
  <div ref={printRef}>
    <RelatorioRupturaPrint
      form={{
        ...form,
        nomeTraco: moldagemSelecionada?.nomeTraco || form.nomeTraco,
        tipoAreaCp: moldagemSelecionada?.tipoAreaCp || form.tipoAreaCp,
        tipoCapeamento: moldagemSelecionada?.tipoCapeamento || form.tipoCapeamento,
        areaCp: moldagemSelecionada?.areaCp || form.areaCp,
      }}
       ensaios={ensaios}
  calcularResistencia={calcularResistencia}
  obraId={form.obraId || moldagemSelecionada?.obraId}
  listaMoldagens={listaMoldagensNumeracao}
  moldagemId={moldagemSelecionada?.id}   // 🔥 ADICIONE AQUI TAMBÉM
  nomeEmpresaSaaS={nomeEmpresaSaaS}
/>
  </div>
</div>
)}

           </Box>
      </Box>
    </>   // 🔥 ADICIONE ESSA LINHA
)}

      <Dialog
        open={openConfirmarCancelamento}
        onClose={() => setOpenConfirmarCancelamento(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Cancelar alterações</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Todos os dados alterados serão perdidos. Deseja continuar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setNavegacaoPendente(null);
            setOpenConfirmarCancelamento(false);
          }}>
            Não
          </Button>
          <Button color="error" variant="contained" onClick={confirmarCancelarAlteracoes}>
            Sim, cancelar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAvisoPrensa} onClose={fecharAvisoPrensa} fullWidth maxWidth="sm">
        <DialogTitle>Atenção</DialogTitle>
        <DialogContent dividers>
          <Typography>
            {mensagemAvisoPrensa}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={fecharAvisoPrensa}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
        slotProps={{
          transition: {
            onEntered: () => {
              if (!modoEdicao) {
                dataMoldagemInputRef.current?.focus({ preventScroll: true });
              }
            },
          },
        }}
      >
        <DialogTitle>
          {modoEdicao ? "Editar Moldagem" : "Nova Moldagem"}
        </DialogTitle>

        <DialogContent
          dividers
          data-moldagem-dialog-container="true"
          onKeyDownCapture={handleEnterDialogMoldagem}
        >
          <Stack spacing={2} mt={1}>

       
              <>

             {exibirCamposCodigoInicial && mostrarInputCodigo && (
  <>
    <TextField
      label="Código inicial da obra"
      type="number"
      value={codigoInicialInput}
      onChange={(e) => setCodigoInicialInput(e.target.value)}
      onWheel={impedirAlteracaoNumeroNoScroll}
      fullWidth
      sx={{ mb: 2 }}
    />

    <TextField
      label="Código inicial caminhão"
      type="number"
      value={codigoInicialCaminhaoInput}
      onChange={(e) => setCodigoInicialCaminhaoInput(e.target.value)}
      onWheel={impedirAlteracaoNumeroNoScroll}
      fullWidth
    />
  </>
)}
                <Autocomplete
                    options={clientes}
                    getOptionLabel={(option) => option?.nome || ""}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={clienteSelecionado}
                    onChange={(event, newValue) => {
                      setClienteSelecionado(newValue);

                      setForm(prev => ({
                        ...prev,
                        cliente: newValue?.nome || "",
                        clienteId: newValue?.id || null,
                        obra: "",
                        concreteira: ""
                      }));

                      carregarObrasPorCliente(newValue?.id);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cliente"
                        placeholder="Pesquisar cliente..."
                        fullWidth
                      />
                    )}
                  />

                <TextField
                        select
                        label="Obra"
                        value={form.obraId || ""}
                        onChange={async (e) => {
  const obraSelecionada = obrasSistema.find(
    o => o.id === e.target.value
  );

  const obraId = obraSelecionada?.id || null;

  setForm({
    ...form,
    obra: obraSelecionada?.nome || "",
    obraId: obraId
  });

  // 🔥 BUSCAR DADOS DA OBRA
  if (obraId) {
    const snap = await getDoc(doc(db, "obras", obraId));

    if (snap.exists()) {
      const obraData = snap.data();
      const rupturaExternaPadrao = obraData.rupturaExternaPadrao === true;

      setObraDados(obraData);
      setForm((formAtual) => ({
        ...formAtual,
        ...(!ensaioEditando
          ? { concreteira: obraData.responsavelProducaoConcreto || "" }
          : {}),
        rupturaExterna: rupturaExternaPadrao,
        ...(!ensaioEditando && rupturaExternaPadrao
          ? { responsavelMoldagem: "construtora", moldador: "N/I" }
          : {}),
        prensaRuptura: rupturaExternaPadrao ? null : formAtual.prensaRuptura,
      }));
      setCodigoInicialInput(obraData.codigoInicial || "");
setCodigoInicialCaminhaoInput(obraData.codigoInicialCaminhao || "");
      setMostrarInputCodigo(
  obraData.codigoInicial === undefined ||
  obraData.codigoInicialCaminhao === undefined
);
    } else {
      setObraDados(null);
      setForm((formAtual) => ({
        ...formAtual,
        rupturaExterna: false,
      }));
      setMostrarInputCodigo(true);
    }
  } else {
    setObraDados(null);
    setMostrarInputCodigo(true);
  }
}}
                        fullWidth
                        disabled={!clienteSelecionado}
                      >
                    {obrasSistema.map((obra) => (
                      <MenuItem key={obra.id} value={obra.id}>
                        {obra.nome}
                      </MenuItem>
                    ))}
                  </TextField>
                
                <TextField label="Data Moldagem" type="date"
                  inputRef={dataMoldagemInputRef}
                  InputLabelProps={{ shrink: true }}
                  required
                  error={erroDataMoldagem}
                  helperText={
                    erroDataMoldagem ? "Data da moldagem é obrigatória." : ""
                  }
                  value={form.datamoldagem}
                  onChange={(e) => {
                    setErroDataMoldagem(false);
                    setForm({ ...form, datamoldagem: e.target.value });
                  }} />

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <TextField
                    label="Hora início da concretagem"
                    type="time"
                    InputLabelProps={{ shrink: true }}
                    value={form.inicioConcretagem || ""}
                    onChange={(e) =>
                      setForm((anterior) => ({
                        ...anterior,
                        inicioConcretagem: e.target.value,
                      }))
                    }
                    fullWidth
                  />
                  <TextField
                    label="Hora término da concretagem"
                    type="time"
                    InputLabelProps={{ shrink: true }}
                    value={form.terminoConcretagem || ""}
                    onChange={(e) =>
                      setForm((anterior) => ({
                        ...anterior,
                        terminoConcretagem: e.target.value,
                      }))
                    }
                    fullWidth
                  />
                </Stack>

                <Autocomplete
                  freeSolo
                  options={concreteiras.map((concreteira) => concreteira.nome)}
                  value={form.concreteira || ""}
                  onChange={(_, valor) =>
                    setForm((anterior) => ({
                      ...anterior,
                      concreteira: valor || ""
                    }))
                  }
                  onInputChange={(_, valor) =>
                    setForm((anterior) => ({
                      ...anterior,
                      concreteira: valor
                    }))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Responsável pela produção do concreto (concreteira ou rodado na obra)"
                      helperText="Selecione uma concreteira cadastrada ou digite manualmente."
                    />
                  )}
                />
                  <FormControl>
  <Typography sx={{ fontWeight: 600 }}>
    Responsável pela Moldagem
  </Typography>
  <RadioGroup
    value={form.responsavelMoldagem}
    onChange={(e) =>
      setForm({ ...form, responsavelMoldagem: e.target.value })
    }
  >
    <FormControlLabel
      value="concreto_engenharia"
      control={<Radio />}
      label={` ${nomeEmpresaSaaS}`}
    />
    <FormControlLabel
      value="construtora"
      control={<Radio />}
      label=" Construtora/Contratante"
    />
  </RadioGroup>
</FormControl>

<Box
  sx={{
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr auto" },
    gap: 1,
    alignItems: "center"
  }}
>
  <TextField
    label="Moldador"
    value={form.moldador}
    disabled={String(form.moldador || "").toUpperCase() === "N/I"}
    onChange={(e) => setForm({ ...form, moldador: e.target.value })}
  />
  <FormControlLabel
    control={
      <Checkbox
        checked={String(form.moldador || "").toUpperCase() === "N/I"}
        onChange={(e) =>
          setForm({
            ...form,
            moldador: e.target.checked ? "N/I" : ""
          })
        }
      />
    }
    label="N/I (Não informado)"
  />
</Box>

<FormControlLabel
  control={
    <Checkbox
      checked={form.rupturaExterna === true}
      onChange={(e) =>
        setForm({
          ...form,
          rupturaExterna: e.target.checked,
          prensaRuptura: null
        })
      }
    />
  }
  label="Ruptura externa (resultados enviados pelo cliente)"
/>

{[
  ["nomeTraco", "Nome do Traço"],
  ["fckProjeto", "FCK de Projeto"],
  ["slumpProjeto", ehSlumpFlow(form.slumpProjeto) ? "Slump Flow de Projeto" : "Slump Test de Projeto"],
  ["toleranciaSlumpProjeto", ehSlumpFlow(form.slumpProjeto) ? "Tolerância do Slump Flow (mm)" : "Tolerância do Slump (mm)"]
].map(([campo, label]) => {
  const naoInformado = String(form[campo] || "").toUpperCase() === "N/I";

  return (
    <Box
      key={campo}
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "260px auto" },
        gap: 1,
        alignItems: "center",
        justifyContent: "start"
      }}
    >
      <TextField
        label={label}
        value={form[campo]}
        disabled={naoInformado}
        onChange={(e) =>
          setForm({ ...form, [campo]: e.target.value })
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={naoInformado}
            onChange={(e) =>
              setForm({
                ...form,
                [campo]: e.target.checked ? "N/I" : ""
              })
            }
          />
        }
        label="N/I (Não informado)"
      />
    </Box>
  );
})}

<FormControl>
  <Typography sx={{ fontWeight: 600 }}>
    Tipo / Área do CP
  </Typography>
  <RadioGroup
    value={form.tipoAreaCp}
    onChange={(e) =>
      setForm({
        ...form,
        tipoAreaCp: e.target.value,
        areaCp: e.target.value === "10x20" ? 7854 : ""
      })
    }
  >
    <FormControlLabel
      value="10x20"
      control={<Radio />}
      label="10x20 (7854 mm²)"
    />
    <FormControlLabel
      value="personalizado"
      control={<Radio />}
      label="Digitar Área"
    />
  </RadioGroup>
</FormControl>

{form.tipoAreaCp === "personalizado" && (
  <TextField
    label="Área do CP (mm²)"
    type="number"
    value={form.areaCp}
    onChange={(e) =>
      setForm({ ...form, areaCp: e.target.value })
    }
    onWheel={impedirAlteracaoNumeroNoScroll}
  />
)}

<TextField
  label="Tipo de Capeamento"
  value={form.tipoCapeamento}
  onChange={(e) =>
    setForm({ ...form, tipoCapeamento: e.target.value })
  }
/>
                {/* TIPO DESCARGA */}
                <FormControl>
                  <Typography sx={{ fontWeight: 600 }}>
                    Tipo de Descarga
                  </Typography>
                  <RadioGroup
                    row
                    value={form.tipoLancamento}
                    onChange={(e) =>
                      setForm({ ...form, tipoLancamento: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="bombeado"
                      control={<Radio />}
                      label="BOMBEADO"
                    />
                    <FormControlLabel
                      value="convencional"
                      control={<Radio />}
                      label="DESCARGA DIRETA"
                    />
                    <FormControlLabel
                      value="nao_informado"
                      control={<Radio />}
                      label="N/I"
                    />
                  </RadioGroup>
                </FormControl>

                <TextField
                  label="Qtd Caminhões"
                  type="number"
                  value={form.qtdCaminhoes || ""}
                  onChange={(e) =>
                    setForm({ ...form, qtdCaminhoes: Number(e.target.value) })
                  }
                  onWheel={impedirAlteracaoNumeroNoScroll}
                />
                <TextField
                    label="Quantidade de Idades"
                    type="number"
                    value={form.qtdIdades || ""}
                    onWheel={impedirAlteracaoNumeroNoScroll}
                    onChange={(e) => {
                      const qtd = Number(e.target.value);

                      setForm({
                        ...form,
                        qtdIdades: qtd,
                        idades: Array.from({ length: qtd }, () => ({
                          dias: ""
                        }))
                      });
                    }}
                  />


                  {form.idades?.map((idade, index) => (
  <TextField
    key={index}
    label={`Dias da Idade ${index + 1}`}
    type="text"
    value={idade.dias}
    onChange={(e) => {
      const novasIdades = [...form.idades];
      novasIdades[index].dias = e.target.value;
      setForm({ ...form, idades: novasIdades });
    }}
    sx={{ mt: 2 }}
  />
))}
                
              </>
         

          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
              onClick={() => {
                setOpenDialog(false);
                setEnsaioEditando(null);
                setErroDataMoldagem(false);
              }}
            >
              Cancelar
            </Button>

          {modoEdicao && (
            <Button
              variant="contained"
              onClick={() => salvarEnsaio(false)}
              disabled={salvando}
            >
              {salvando ? "Salvando..." : "Salvar"}
            </Button>
          )}

          {!modoEdicao && (
            <Button
              variant="contained"
              color="success"
              onClick={() => salvarEnsaio(true)}
              disabled={salvando}
            >
              {salvando ? "Salvando..." : "Salvar e abrir"}
            </Button>
          )}

        </DialogActions>
        </Dialog>

        </Box>
  </Box>
);

}
